const messages = {
  // eslint-disable-next-line id-length
  en: {
    $auth: {
      title: "Authenticating",
      socials: {
        google: "Continue with Google",
      },
      registration_consent: {
        header: "You are creating a new account with {appName}!",
        sub_header: "Confirm and complete your details below",
        privacy_policy: {
          content: "By clicking Continue you agree to our {terms_url} and {privacy_url}",
          links: {
            terms_and_condition: "Terms & Conditions",
            privacy_policy: "Privacy Policy",
          },
        },

        actions: {
          continue: "CONTINUE",
        },
        error: "Something went wrong",
        form: {
          fields: {
            first_name: "First Name",
            last_name: "Last Name",
          },
          rules: {
            first_name: {
              empty: "Please provide your first name.",
              char_limit: "First name must not exceed 50 characters",
            },
            last_name: {
              empty: "Please provide your last name.",
              char_limit: "Last name must not exceed 50 characters",
            },
          },
          actions: {
            submit: "Continue",
          },
        },
      },
      login_required: {
        header: (ctx) => {
          const ssoApp = ctx.named("ssoApp");
          if (ssoApp) {
            return `Please login first and we'll hook you up to ${ssoApp}`;
          }
          return `Please login first and we'll hook you up to the application`;
        },
        forgot_password: "Forgot Password?",
        errors: {
          invalid_password: "Invalid Password",
        },
        form: {
          email: "Email",
          password: "Password",
          submit: "Login",
        },
      },
      pending_account_verification: {
        header: "Almost there!",
        sub_header: "A verification email has been sent to",
        instructions: "Please check your email and click on the verification link to get started.",
        notification: {
          success_resend: "Email has been resent.",
        },
        change_email_header: "Change your email address",
        change_email_subheader: "A new email will be sent to the address below.",
        actions: {
          resend: "Resend Email",
          change_email: "Not this email?",
          confirm: "CONFIRM",
          back: "BACK",
        },
        form: {
          email: {
            label: "Email",
            error: "Please provide a valid email address.",
          },
        },
      },
      account_verification: {
        expired: "The verification link is expired. Please click here to resend.",
        success: "Your account has been verified successfully.",
        actions: {
          start: "START USING {platformName}",
        },
      },
    },
    $success_messages: {
      VERIFY_ACCOUNT: "Your account has been verified successfully.",
      RESEND_VERIFICATION_LINK: "Please check your email for a verification link.",
      RESEND_INVITE_NEW_DEVICE: "Please check your email on your other device to continue.",
      ADD_CARD: "Credit card registered.",
      REMOVE_CARD: "Credit card removed.",
      ENQUIRY: "Enquiry sent! We will get back to you within 3 working days.",
      INVITATION: "Invitation sent successfully!",
      VERIFY_EMAIL_CHANGE: "Please check your current email to verify the email change.",
      PASSWORD_CHANGED: "Password has been changed successfully!",
      COMPANY_SHARES: "Company shares have been saved successfully!",
      INVITATION_COMPLETE_PROFILE: "Your profile has been successfully updated.",
      SEND_DOCUMENT_ERROR_EMAIL: "Successfully sent! Sleek will contact you about the error that has been reported.",
      SEND_COMMENT: "Successfully sent!",
    },
    $navigation: {
      company_info: "Company Info",
      company_id: "Company ID",
      organization: "Organization",
      mailroom: "Mailroom",
      sleeksign: "SleekSign",
      sleeksign_send_document: "Send a document",
      sleeksign_document: "Document",
      company_secretary: "Company Secretary",
      accounting: "Accounting",
      acct_packages: "Packages",
      acct_files: "Files",
      referral: "Invite & earn {amount}",
      perks: "Perks",
      billings: "Billings & Subscriptions",
      enquiry: "Enquiry",
      preferences: "Preferences",
      myprofile: "My profile & settings",
      invitations: "Invitations",
      logout: "Log out",
      login: "Log In",
      add_new: "Add company",
      delete_company: "Delete company",
      clear_all_info: "This will clear all the information you entered for:",
      cannot_be_undone: "This action cannot be undone",
      draft_company: "DRAFT COMPANY",
      inprogress_company: "IN PROGRESS",
      cancel: "Cancel",
      shopping_cart: {
        heading: "Summary",
        item: {
          name: "Item Name",
          price: "Price",
        },
        subtotal: "Subtotal",
        buttons: {
          checkout: "CHECKOUT",
        },
      },
      sleeksign_nav: {
        description: "Need to sign a contract?",
        link: "Use SleekSign",
      },
      support: "Support",
    },
    $login: {
      welcome_v1: "Welcome to",
      welcome: "Welcome Back!",
      password_not_match_records: "The email or password does not match our records.",
      tagged_user: "This company will be tagged to your Sleek account",
      email_label: "Email",
      password_label: "Password",
      forgot_password: "Forgot Password?",
      login: "Log In",
      create_account: "Create Account",
      new_to_sleek: "New to Sleek?",
      request_for_reset: "Enter your account email address to request for a password reset.",
      instructions_to_reset: "Please check your mail inbox for the instruction to reset your password.",
      instructions_to_reset_generic:
        "If your email address exists in our system, we'll send you an email with further instructions.",
      invalid_email: "Please provide a valid email address.",
      incorrect_email_or_password: "Incorrect email or password.",
      submit: "Submit",
      back: "Back",
      error: "Error",
      success: "Success",
      reset_password: "Reset Password",
      new_password: "New password",
      confirm_password: "Confirm password",
      password_length: "Password must be <strong>at least 8 characters</strong> long",
      password_uppercase: "The password must contain at least one uppercase character (A-Z)",
      password_digit: "The password must contain at least 1 digit (0-9)",
      password_special_char: "The password must contain at least 1 special character",
      passwords_do_not_match: "Passwords do not match.",
      reset_successfully: "You have successfully reset your password.",
      logged_in_as: "You are logged in as",
      logout: "Log out",
    },
    $secretary: {
      company_secretary: "Company Secretary",
      search_files: "Search files",
      secretary: "Secretary",
      download: "Download",
    },
    $createuser: {
      new_account: "New Account",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      password: "Password",
      confirm_password: "Confirm Password",
      agreement_fulltext: "I agree to the {0} and {1}.",
      agreement_1: "Terms & Conditions",
      agreement_2: "Privacy policy",
      back: "BACK",
      register: "REGISTER",
      success: "SUCCESS",
      error: "ERROR",
      success_message: "Your account has been created successfully. Please check your email to verify your account.",
      ok_btn: "ok",
      provide_firstname: "Please provide your first name.",
      provide_lastname: "Please provide your last name.",
      provide_email: "Please provide a valid email address.",
      email_is_taken: "Email is already taken",
      please_confirm_password: "Please confirm your password",
      passwords_do_not_match: "Passwords do not match.",
      firstname_not_exceeed_50: "First name must not exceed 50 characters",
      lastname_not_exceed_50: "Last name must not exceed 50 characters",
    },
    $incorporate: {
      welcome_fulltext: "Welcome, {0}. Your {1} is in progress.",
      incorporationType_incorporation: "incorporation",
      incorporationType_transfer: "transfer",
      set_up_sleek: "Set up in Sleek",
      share_compliance: "Shares and Compliance",
      compliance: "Compliance",
      minute_15: "15 min",
      minute_5: "5 min",
      minutes_15: "15 mins",
      minutes_5: "5 mins",
      live: "Live",
      sign_and_process: "Sign and process documents",
      static_working_days: "Up to {0}",
      working_days_3: "3 working days",
      working_days_2: "2 working days",
      days_2_3: "2-3 days",
      days_4_6: "4-6 days",
      days_3_5: "3-5 days",
      accounting_setup: "Accounting Setup",
      accounting_setup_2: "Accounting setup",
      minute_10: "10 min",
      minutes_10: "10 mins",
      here_you_will_need_to_complete:
        "Here you will need to complete remaining details about your new company and Sleek will help to set up your accounting service.",
      company_name: "Company name",
      cr_no: "CR No.",
      will_be_available: "Will be available after successful filing.",
      will_be_available_ACRA: "Will be available after successful filing with ACRA.",
      br_no: "BR No.",
      business_activity: "Business activity",
      company_description: "Company description",
      company_address: "Company address",
      company_members: "Company members",
      payment_made: "Payment made",
      view_invoice: "View invoice",
      share_allocation: "Share allocation",
      share_allocation_dialog_content_p1:
        "Here you will indicate the number of shares held for each shareholder, as well as value per share. In {countryName}, it is possible to incorporate your company with a low share capital ({currencyCode} 1.00).",
      share_allocation_dialog_content_p2:
        "As soon as the company is incorporated, it is possible to increase the share capital.",
      read_more: "Read more",
      identity_verification: "Identity verification",
      share_allocation_v2: "Share Allocation",
      identity_verification_v2: "Identity Verification",
      shares_and_identity_verification: "Shares and identity verification",
      processing_incorporation: "Processing incorporation",
      allocate_company_shares: "Allocate your company's shares",
      sign_process_documents: "Sign and process documents",
      incorporation_documents: "Incorporation documents",
      pre_incorporation_documents: "Pre-incorporation documents",
      these_documents_will_be_sent: "These documents will be sent to your email for electronic signature:",
      pending_signatures_preincorporation: "Pending signatures for pre-incorporation documents.",
      your_compliance_is_completed: "Your compliance check is now completed!",
      company_is_live: 'Company is "Live" on {0}',
      your_incorporation_process_ongoing:
        'Your incorporation process is still on-going, even as your company is now "Live" on {0}',
      sleek_is_now_preparing:
        "Sleek is now preparing the next set of documents for your signature to complete incorporation.",
      documents_all_signed: "Documents all signed!",
      sleek_will_proceed: "Sleek will proceed to incorporate your company with {0}",
      we_are_preparing: "We are preparing the pre-incorporation documents, which will take up to {0}",
      the_processing_time_will_take: "The processing time will take up to {0}",
      once_they_are_signed:
        "Once they are signed and returned to us, we will proceed with your company's incorporation.",
      post_incorporation_documents: "Post-incorporation documents",
      after_company_incorporated:
        "After your company is incorporated, we will prepare the post-incorporation documents and send them to your email for electronic signature:",
      all_these_will_be_saved: "All of these documents will be saved on your Sleek account.",
      company_status: "Company status",
      congratulations_text: "Congratulations!",
      incorporation_process_fully_complete: "The incorporation process is now fully completed for your company.",
      please_proceed_to_complete: "Please proceed to complete the set up for your accounting services.",
      proceed_to_stage_4_btn: "PROCEED TO STAGE 4",
      hk_documents: {
        pre_incorp_documents: ["Articles of Association", "Form NNC1"],
        post_incorp_documents: [
          "Appointment of First Directors",
          "First Board Resolution",
          "Significant Controller Registers",
        ],
      },
      awaiting_payment: "Awaiting payment {amount}",
      compliance_dialog_content: {
        p_1: "Here you will need to complete identity verification as part of our KYC (Know Your Customer) process.",
        p_2: "Each company member will complete this individually. An invitation email will be sent automatically to all company members added in Stage 1.",
        p_3: "After submitting KYC information, if there are any changes to the company director's details, you can notify our Customer Support at <a href='mailto:{support_email}'>{support_email}</a> within 14 days.",
        p_4: "Sleek will start processing incorporation documents once KYC is completed for all company members.",
      },
      sign_documents_dialog_content: {
        p_1: {
          incorporation:
            "We are preparing the necessary documents to incorporate your company, which will take up to 3 working days.",
          transfer:
            "We are preparing the necessary documents to finalise your transfer, which will take up to 3 working days.",
        },
        p_2: {
          incorporation:
            "Upon signature, we will submit the incorporation application to the Company Registry (CR) and Inland Revenue Department (IRD) of the change.",
          transfer:
            "A <b>board resolution executing the changeover</b> will be sent to your email for electronic signature. Upon signature, we will inform the Company Registry (CR) and Inland Revenue Department (IRD) of the change.",
        },
        p_3: "All of these documents will be saved on your Sleek account.",
      },
      stepper: {
        share_allocation: {
          more_about_shares: "More about shares",
          more_about_shares_description_incorporation:
            "In Hong Kong it is possible to incorporate your company with a low Share Capital (HKD 1.00). <br /> Don't worry if you want to add more later. <br /> It is possible to increase the Share Capital as soon as the company is incorporated.",
          more_about_shares_description_transfer:
            "Please enter shareholdings as currently reflected on your Business Profile. <br /> Changes to shareholding can be made once transfer process is completed.",
          no_of_shares_held_and_value: "No. of Shares held and value per share",
          no_of_shares_held_companies:
            "Number of shares held are the number of shares allocated to each shareholder. Companies usually value one share at 1 dollar.",
          no_of_shares_held: "No. of shares held",
          value_per_share: "Value per share",
          hkd: "HKD",
          issued_share_capital: "Issued share capital",
          class_of_shares: "Class of shares",
          ordinary_share_type: "ORDINARY",
          currency: "Currency",
          total_no_shares: "Total No. of shares",
          total_issued_capital: "Total issued share capital",
          the_total_sum_money:
            "The total sum of money invested in the company at that point (e.g. combined investment from all shareholders).",
          back: "BACK",
          save_and_next: "SAVE & NEXT",
          contact_us: "CONTACT US",
          proceed_to_stage_3: "PROCEED TO STAGE 3",
        },
        identity_verification: {
          verified: "Verified",
          complete_profile: {
            complete_your_profile: "Complete your profile",
            complete_profile_button: "Complete Profile",
            complete_profile_button_capital: "COMPLETE PROFILE",
            your_profile_is_completed: "Your profile is already completed.",
            personal_information: "Personal information",
            identity_documents: "Identity documents",
            residential_information: "Residential information",
            declaration: "Declaration",
          },
          of_company_members: "Identity verification of company members",
          notification_email_has_been_sent:
            "A notification email has been sent to company members who require further actions for identity verification.",
          remind_all_capital: "REMIND ALL",
          send_email_reminder:
            "Send an email reminder to all your company members. Once they receive the invitation email, they can click on the link of the email, sign up on Sleek platform and input the information needed to proceed to their identity verification.",
          remind_all: "Remind all",
          back_button: "BACK",
          save_and_next_buttons: "SAVE & NEXT",
        },
        acct_setup: {
          finance_details_title: "Finance details",
          finance_details_tooltip:
            "The details you provide here will be used to setup your Xero account: <br/><br/>1. Company operations - details about your clients and invoicing methods.<br/><br/>2. Bank details<br /><br/>3. Book a webinar with our Accounting expert to walk you through how it all works.",
          finance_details_text: "Please indicate the Finance contact person to proceed with setup.",
          finance_contact_person: "Finance contact person",
          proceed: "Proceed",
          payroll_details_title: "Payroll details",
          tax_details_title: "Tax details",
          payroll_details_tooltip:
            "The details you provide here will be used to setup your Talenox account: <br/><br/>1. Employee data - download the employee data template and submit the completed data.<br/><br/>2. Upload employee documents - upload employee contracts and permanent residency documents if applicable.",
          payroll_details_text1: "Does your company need payroll support?",
          payroll_details_text2: "Please indicate the HR contact person to proceed with setup.",
          payroll_details_text3: "Do you have an existing payroll scheme setup?",
          hr_contact_person: "HR contact person",
          view_dashboard: "View dashboard",
          back: "Back",
          done: "Done",
          company_members: "Company members:",
          add_manually: "Add manually",
          notify: "Notify",
          first_name: "First name",
          last_name: "Last name",
          email: "Email",
          phone_number: "Phone number",
          required: "Required",
          provide_first_name: "Please provide your first name",
          provide_last_name: "Please provide your last name",
          provide_valid_email: "Please provide a valid email address",
          provide_phone_number: "Please provide your phone number",
          FINANCE_DETAIL_STATUSES: {
            IN_PROGRESS: {
              label: "Email sent",
              value: "IN_PROGRESS",
            },
            DONE: {
              label: "Completed",
              value: "DONE",
            },
          },
          PAYROLL_DETAIL_STATUSES: {
            IN_PROGRESS: {
              label: "Email sent",
              value: "IN_PROGRESS",
            },
            DONE: {
              label: "Completed",
              value: "DONE",
            },
          },
        },
        financial_details: {
          preAccInfoFirstname: "First name",
          preAccInfoLastname: "Last name",
          preAccInfoEmail: "Email",
          preAccInfoPhone: "Phone Number",
          preAccInfoQ: "Please indicate your previous accountant information",
          company_setup_tax_ref: "Company UTR",
          company_setup_auth_code: "Company House Authentication Code",
          others: "Others",
          bank_list: [],
          company_operations: "Company Operations",
          company_operations_text:
            "Please provide details about your clients and invoicing methods.<br/>(Optional) Upload your company logo and invoice template if available.",
          accounting_software: "Accounting software",
          accounting_software_text: "Select your preferred accounting software",
          accounting_software_preselected_text: "You selected Xero when you signed up",
          start: "Start",
          company_setup: "Company Setup",
          company_setup_text:
            "Understanding your current setup helps to set up your account faster.<br/><br/>If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          company_setup_q1: "Which accounting method was your company using before working with Sleek?",
          select_software: "Select software",
          currency_selector_question: "Do you use more than one currency?",
          accounting_tutorial: {
            label: "",
            sub_label: "",
            btn_text: "",
          },
          tax: {
            title: "Tax",
            add_individual: "Add Individual",
          },
          accounting_software_options: [],
          method_to_invoice_clients_options: [
            {
              text: "Prepare manually in Excel or Word and send by email",
              type: "excel",
              value: "Prepare manually in Excel or Word and send by email",
            },
            {
              text: "Send directly to the client from my accounting software",
              type: "direct",
              value: "Send directly to the client from my accounting software",
            },
            {
              text: "Send to the client from an invoicing platform",
              type: "via-platform",
              value: "Send to the client from an invoicing platform",
            },
            {
              text: "I don't send invoices to my clients (e.g. holding company)",
              type: "does-not-send",
              value: "I don't send invoices to my clients (e.g. holding company)",
            },
            {
              text: "I am not sure yet",
              type: "not-sure",
              value: "I am not sure yet",
            },
          ],
          issued_sales_invoices_options: [
            {
              text: "0-5",
              value: "zero-to-five",
            },
            {
              text: "6-20",
              value: "six-to-twenty",
            },
            {
              text: "More than 20",
              value: "greater-than-20",
            },
          ],
          ecommerce_platform_options_v2: [
            {
              text: "None",
              value: "None",
            },
            {
              text: "Shopify",
              value: "Shopify",
              properties: {
                store_name: {
                  label: "Store name",
                  extension: ".myshopify.com",
                },
              },
            },
            {
              text: "WooCommerce",
              value: "WooCommerce",
              properties: {
                shop_url: {
                  label: "Shop URL",
                },
              },
            },
            {
              text: "Wix",
              value: "Wix",
            },
            {
              text: "Squarespace",
              value: "Squarespace",
            },
            {
              text: "Amazon Marketplace",
              value: "Amazon Marketplace",
              properties: {
                name_owner: {
                  label: "Name owner",
                },
                email_owner: {
                  label: "Email owner",
                },
                region: {
                  label: "Region",
                  choices: [
                    "Amazon.com",
                    "Amazon.ca",
                    "Amazon.com.mx",
                    "Amazon.co.uk",
                    "Amazon.de",
                    "Amazon.fr",
                    "Amazon.es",
                    "Amazon.it",
                    "Amazon.co.jp",
                    "Amazon.com.au",
                    "Amazon.in",
                    "Amazon.ae",
                    "Amazon.sg",
                  ],
                },
              },
            },
            {
              text: "eBay",
              value: "eBay",
              properties: {
                sellers_name: {
                  label: "Sellers name",
                },
                sellers_email: {
                  label: "Sellers email",
                },
              },
            },
            {
              text: "Etsy",
              value: "Etsy",
              properties: {
                sellers_name: {
                  label: "Sellers name",
                },
                sellers_email: {
                  label: "Sellers email",
                },
              },
            },
            {
              text: "Lazada",
              value: "Lazada",
            },
            {
              text: "Shopee",
              value: "Shopee",
            },
            {
              text: "Qoo10",
              value: "Qoo10",
            },
            {
              text: "Other",
              value: "Other",
              properties: {
                platform: {
                  label: "Specify Platform",
                },
              },
            },
          ],
          company_setup_q2: "Who are the typical clients of your company? ",
          examples: "e.g. B2C, SMEs, Foreign MNCs",
          invoice_setup: "Invoice Setup",
          invoice_q1: "How does your company invoice its clients? *",
          invoice_method: "Invoicing method",
          invoice_platform: "Invoicing Platform (e.g Shopify, Stripe)",
          prepare_manually: "Prepare manually in Excel or Word and send by email",
          send_direct_from_software: "Send directly to the client from my accounting software",
          send_from_invoice_platform: "Send to the client from an invoicing platform",
          donot_send: "I don't send invoices to my company (e.g. holding company)",
          notsure: "I am not sure yet",
          invoice_q2: "How many sales invoices does your company issue on average per month? *",
          select_inv_count: "Select Invoice Count",
          morethan20: "More than 20",
          please_upload_logo: "Please upload your company logo (optional)",
          upload_format: "Format: JPG, PNG. Max size: 5MB per file.",
          upload_format_with_pdf: "Format: PDF, JPG, PNG. Max size: 5MB per file.",
          add_files: "ADD FILES",
          upload_invoice_template: "Please upload your invoice template (optional)",
          ecommerce_setup: "E-commerce setup",
          ecommerce_q1: "Which e-commerce platform does your company sells on?",
          ecommerce_text1: "You can also type in the platform name below",
          ecommerce_platform: "E-commerce platform",
          commonly_used: "Commonly used",
          specify_platform: "Specify platform",
          add_more_platforms: "Add more platforms",
          currency_bank_details: "Functional currency",
          currency_bank_details_content: "Specify the currencies used by your business",
          currency_bank_details_lists: [],
          currency_bank_details_subcontent: "",
          your_bank_details: "Your functional currency",
          indicate_your_bank_details: "",
          accounting_plan_includes: "Your accounting plan includes: {currencyDescription}",
          indicate_main_currency: "Please indicate the main currency for your business transactions.",
          indicate_other_currency: "Please indicate all other currencies that you transact in.",
          functional_currency: "Functional currency",
          functional_currency_tooltip:
            "Functional currency refers to the currency that you choose to do all your accounting in. <br><br>It should be the currency in which you conduct the majority of your business transactions and that your business may receive any funding in.",
          request_from_pm: "REQUEST FROM PRODUCT MANAGER",
          currency_is_required: "Currency is required",
          bank_accounts_details: "Please provide the details of the bank accounts used by your business.",
          bank_selection:
            "Select a bank from the list. The main banks in Singapore are represented. <br>If nevertheless your bank doesn’t appear in the list, you can add it by typing the name. You can also include payment accounts such as PayPal or Stripe.",
          name_of_bank: "Name of bank",
          account_no_or_id: "Account number or ID",
          currency: "Currency",
          add_more_banks: "Add more banks",
          no_bank_account:
            "In case your company doesn’t have a bank account yet, simply click on the Red Cross, then press ‘Save & Next’.",
          required_field: "Required field",
          bank_details_save_successfully: "Functional currency has been saved successfully.",
          accounting_software_save_successfully: "Accounting Software has been saved successfully.",
          back: "Back",
          save_and_next: "Save & Next",
          save_successfully: "Company Operations have been saved successfully.",
          onboarding_webinar: "Free Onboarding Webinar (optional)",
          onboarding_webiner_text1:
            "After completing both steps above, you can book a webinar session with one of our Accounting experts who will walk you through how it all works.",
          onboarding_webiner_text2: "If you prefer not to have the webinar, simply click one the DONE button below.",
          book_webinar: "Book webinar",
          webinar: "Webinar",
          webinar_content: "Book a webinar with our Accounting expert to walk you through how it all works.",
          type_of_entities: {
            question: "",
            options: [],
          },
          other_business_management_app: {
            question1: "",
            examples: "",
          },
        },
        payroll_details: {
          header_title: "Payroll details",
          tax_details: "Tax details",
          employee_data: "Employee data",
          payroll_step: "Payroll",
          employer_paye_side_header: "PAYE references",
          employer_paye_side_subheader:
            "A PAYE reference number (or Employer Reference Number) consists of a unique set of letters and numbers used by HMRC to identify your employer and their Pay As You Earn (PAYE) scheme.",
          paye_text: "Add employee PAYE reference",
          paye_tooltip: "",
          paye_office_number_placeholder: "Office Number",
          paye_reference_number_placeholder: "Employer PAYE reference",
          paye_accounts_office_reference_placeholder: "Accounts Office Reference",

          p11d_side_header: "P11D",
          p11d_side_subheader:
            "If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          p11d_text: "Are you required to submit P11D's?",
          generic_upload_text: "Please upload the following documents:",
          p11d_upload_file_list: "A copy of last year's P11D(b) and P11D's",
          p11d_upload_file_format: "Format:",
          p11d_upload_max_size: "<b>Max size:</b> 5MB per file.",

          pension_scheme_side_header: "Pension Scheme",
          pension_scheme_side_subheader:
            "If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          pension_scheme_text: "Do you have a registered pension scheme?",
          pension_scheme_employer_id_placeholder: "Employer ID",
          pension_scheme_pension_regulator_letter_code_placeholder: "Pension Regulator Letter Code",

          tax_side_header: "Tax",
          tax_side_subheader:
            "If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          vat_number_placeholder: "VAT Number",
          vat_certificate_upload_list: "A copy of your VAT certificate",
          vat_upload_file_format: "Format:",
          vat_upload_max_size: "<b>Max size:</b> 5MB per file.",

          payroll_data_step_saved: "Payroll Data is saved successfully.",
          tax_data_step_saved: "Tax Data is saved successfully.",

          employee_data_content: "Download the employee data template and submit the completed data.",
          upload_employee_documents: "Upload employee documents",
          upload_employee_documents_content: "Please prepare the following documents for each employee:",
          upload_employee_documents_lists: ["Employment contract"],
          superannuation_form: "Superannuation standard choice form",
          superannuation_form_details:
            "Superannuation is a special savings account that helps you save for retirement. Choose a fund that meets your needs to ensure that you have enough money to retire comfortably.",
          tax_declaration_form: "Tax File Number (TFN) declaration form",
          tax_declaration_form_details:
            "Your TFN is a unique number that identifies you to the Australian Taxation Office (ATO) for tax purposes.",
          download_employee_data_template: "Download employee data template",
          download_employee_data_template_tooltip:
            "Please download and use the template provided to submit your employee data.<br><br>The more accurate and complete your data is, the faster your account will be set up.",
          employee_data_form_name: "HK-Employee Data Form",
          complete_all_fiels: "Please complete all the fields provided in the template below.",
          hk_employee_data_form: "HK-Employee data form",
          upload_employee_data: "Upload employee data",
          upload_employee_data_subtitle:
            "The data will be used to set up payroll in Talenox.<br><br>If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          indicate_no_of_employees: "Please indicate number of employees",
          no_of_employees: "Number of employees",
          upload_employee_data_spreadsheet: "Upload your employee data spreadsheet",
          upload_format: "Format: XLSX. Max size: 5MB per file.",
          add_files: "Add files",
          need_1_or_more: "Needs to be 1 or more",
          employee_data_saved: "Employee Data is saved successfully.",
          upload_employee_documents_header: "Upload Employee Documents",
          download_complete_forms_title: "Download and complete these forms",
          download_complete_forms_subtitle:
            "This to ensure that you:<br /><br /><ul class='pl-3'><li>Pay the correct tax amount</li><li>Receive any tax refunds or government payments you are entitled to</li>",
          financial_statement: "Financial Statement",
          financial_statement_subtitle:
            "If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          upload_report: "Upload a report that shows the financial activities and performance.",
          financial_statement_types: "Types of financial statements",
          financial_statement_type1: "Balance sheet",
          financial_statement_type2: "Profit and loss statement",
          your_current_setup: "Your current setup",
          your_current_setup_subtitle:
            "Understanding your current setup helps to set up your account faster.<br><br>If you need further assistance, feel free to <a href='/enquiry' target='_blank'>contact us</a>.",
          please_upload: "Please upload the following documents for each employee",
          please_upload_list: "Employment contract",
          drag_and_drop_here: "Drag and drop here",
          upload_or: "or",
          upload_format_only: "Format:",
          upload_maxsize: "<b>Max size:</b> 5MB per file.",
          employee_document_saved: "Employee document is saved successfully.",
          upload: "Upload",
          start: "Start",
          done: "Done",
          back: "Back",
          save_and_next: "Save & Next",
          completed: "Completed",
          button_save: "Save",
          allow_sleek_to_access_tax_details_content:
            "I give permission for Sleek Tech Pty Ltd to have access to our tax details with the Australian Taxation Office *",
          tax_information_content:
            "Information will be collected to generate individual tax return forms for your directors, shareholders and employees.",
          individual_tax_return: {
            title: "Individual Tax Return",
            subtitle: "Details collected will be used to generate your tax return forms.",
            add_btn_text: "Add individual",
            contact_us:
              "If you need further assistance, feel free to <a href='/enquiry' target='_blank'> contact us</a>.",
            forms: {
              personal_information_title: "Personal Information",
              residential_information_title: "Residential Information",
              tax_information_text: "Tax Information",
              tax_information_subtitle:
                "A tax file number (TFN) is your personal reference number in the tax and superannuation systems. It is free to <a href='https://www.ato.gov.au/Individuals/Tax-file-number/Apply-for-a-TFN/' target='_blank'>apply for a TFN</a>. Your TFN is: a unique number (9 digits)",
            },
            address_form: {
              country_code_text: "Country Code",
              city_of_birth_text: "City of Birth",
              state_of_birth_text: "State of Birth",
              country_of_birth_text: "Country of Birth",
            },
            tax_file_number_text: "Tax File Number",
          },
        },
      },
    },
    $dashboard: {
      welcome_text_1: "Welcome, {firstname}. Here's what you can do to get started.",
      welcome_text_2: "Welcome, {firstname}.",
      get_started_text: "Here’s what you can do to get started.",
      lets_go_text: "Let's go",
      //
      card_header_accounting: "Accounting support",
      card_header_sign: "SleekSign",
      card_header_question: "Have a question?",
      card_header_company: "Your company",
      card_header_documents: "Company documents",
      card_header_mailroom: "Mailroom",
      card_header_company_id: "Company ID",
      fully_incorporated: "You can access this after your incorporation is completed.",
      tasks_and_alerts: "tasks and alerts",
      tasks_and_alerts_heading: "Tasks and alerts",
      //
      tile_text_start: "Start a new company",
      tile_text_start_with_sba: "Register a new company & get a free business account",
      tile_text_transfer: "Transfer existing company secretary or accounting services to Sleek",
      tile_text_sign: "Sign documents securely, anywhere in the world. For free!",
      card_text_sign: "Our free service for you to sign documents securely, anywhere in the world.",
      card_text_accounting: "View available accounting services anytime you need it.",
      card_text_question: "Call us at {contact_number}{contact_time}, or email us at",
      //
      card_field_label_registration: "Registration No.",
      card_field_label_status: "Company Status",
      card_field_label_date: "Incorporation Date",
      //
      card_button_get_started: "GET STARTED",
      card_button_quote: "GET A QUOTE",
      card_button_contact: "CONTACT SUPPORT",
      //
      button_view_more: "View More",
      button_view_all: "View all",
      button_accept_invite: "Accept invite",
      //
      card_link_mail: "{email}",
      card_send_enquiry: "Send an enquiry",
      //
      text_snackbar_1:
        "Your KYC Process has been completed! We have completed scanning through your documents and profile details.",
      text_snackbar_2:
        "Welcome to Sleek Platform! We are currently reviewing the documents you have submitted with us as part of our KYC Process.",
      //
      card_text_empty_mailbox: "Your mailbox is empty.",
      //
      alert_message_title_invite: "Invitation",
      you_are_invited_to: "You are invited to <strong>{invitingCompanyName}</strong> as <strong>{userRole}</strong>",
      // Perks
      perks_slider_heading: "Get exclusive offers with our partners",
    },
    $billing: {
      billing_subscriptions: "Billing and Subscriptions",
      credit_balance: "Credit Balance",
      balance_tooltip: "This balance will be applied to your next billing cycle invoice",
      credit: "CREDIT",
      add_card: "Add Credit / Debit Card",
      subscriptions: "Subscriptions",
      renew_add_subs: "Renew or add your subscription now by selecting the boxes.",
      company_secretary: "Company Secretary",
      shareholder: "Shareholder",
      renewal_date: "Renewal Date",
      add: "Add",
      cancel: "Cancel",
      annual_registration_fee: "Annual Business Registration fee to HKSAR",
      registered_address: "Registered Address",
      transactions: "Transactions",
      transaction_date: "Transaction Date",
      description: "Description",
      status: "Status",
      amount: "Amount",
      invoice: "Invoice",
      view: "View",
      rows_per_page: "Rows per page:",
      name_on_card: "Name on Card",
      card_number: "Card Number",
      card_expiry: "Card Expiry",
      card_cvc: "Card CVC",
      name_on_card_error: "Name on card should be minimum 3 character",
      incomplete_card_number: "Your card number is incomplete",
      card_expired: "Your card's expiration year is in the past.",
      cancellation_request: "CANCELLATION REQUEST",
      cancellation_confirmation: "Are you sure you want to request for the cancellation of subscription?",
      request_for_cancellation: "Request for cancellation",
      cards: "Cards",
      no_transactions: "You have no transactions.",
      delete_card_title: "DELETE CARD",
      delete_confirmation:
        "Are you sure you want to delete this card? Any automatic renewals billed on this card would be disabled.",
      subscription_plans: {
        SECRETARY: "Company Secretary",
        NOMINEE_DIRECTOR: "Nominee Director",
        MAILROOM: "Registered Address",
        ACCOUNTING_SLIM: "Accounting Slim",
        ACCOUNTING_STARTUP: "Accounting Startup",
        ACCOUNTING_SME: "Accounting SME",
        ACCOUNTING_SUPREME: "Accounting Supreme",
        CORP_SEC_1_SHAREHOLDER: "Corporate Secretary<br/> (1 Shareholder)",
        CORP_SEC_2_SHAREHOLDER: "Corporate Secretary<br/> (2 Shareholder)",
        CORP_SEC_3_5_SHAREHOLDER: "Corporate Secretary<br/> (3 to 5 Shareholder)",
        CORP_SEC_6_9_SHAREHOLDER: "Corporate Secretary<br/> (6 to 9 Shareholder)",
        CORP_SEC_10_20_SHAREHOLDER: "Corporate Secretary<br/> (10 to 20 Shareholder)",
        CORP_SEC_21_30_SHAREHOLDER: "Corporate Secretary<br/> (21 to 30 Shareholder)",
        CORP_SEC_31_50_SHAREHOLDER: "Corporate Secretary<br/> (31 to 50 Shareholder)",
        ACRA_ANNUAL_FILING_FEE: "ACRA Annual Filing Fee",
        ANNUAL_BUSINESS_REGISTRATION_FEE_TO_HKSAR: "Annual Business Registration fee to HKSAR",
        ACCOUNTING_XBRL_FILE: "Accounting - XBRL File",
        XERO_MULTI_CURRENCY_UPGRADE: "Xero Multi Currency Upgrade",
        DORMANT_COMPANY: "Dormant Company (Accounting + Corpsec)",
        PAYROLL_PER_STAFF: "Payroll Per Staff",
        GST_QUARTERLY_COMPLIANCE: "GST Quarterly Compliance",
        SUPREME_QUARTERLY_PLAN: "Supreme Quarterly Plan - All in Compliance Package",
        SUPREME_PLUS_PLAN: "Supreme Plus Plan - All In Compliance Package",
        A2X_SHOPIFY_MINI: "A2X Shopify - Mini (200 orders/month)",
        A2X_SHOPIFY_BASIC: "A2X Shopify - Basic (500 orders/month)",
        A2X_SHOPIFY_STANDARD: "A2X Shopify - Standard (2,000 orders/month)",
        A2X_SHOPIFY_ADVANCED: "A2X Shopify - Advanced (5,000 orders/month)",
        A2X_AMAZON_MINI: "A2X Amazon - Mini (200 orders/month)",
        A2X_AMAZON_BASIC: "A2X Amazon - Starter (1,000 orders/month)",
        A2X_AMAZON_STANDARD: "A2X Amazon - Standard (5,000 orders/month)",
        A2X_AMAZON_PREMIUM: "A2X Amazon - Premium (10,000 orders/month)",
        ACCT_2_500_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 2.5K Monthly Expenses`,
        ACCT_7_500_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 7.5K Monthly Expenses`,
        ACCT_15_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 15K Monthly Expenses`,
        ACCT_35_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 35K Monthly Expenses`,
        ACCT_50_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 50K Monthly Expenses`,
        ACCT_75_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 75K Monthly Expenses`,
        ACCT_125_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 125K Monthly Expenses`,
        ACCT_175_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 175K Monthly Expenses`,
        ACCT_250_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 250K Monthly Expenses`,
        ACCT_325_000_EXPENSE_ACCOUNTING_PLAN: `Accounting Plan - Up to 325K Monthly Expenses`,
        GST_ANNUAL_COMPLIANCE: "GST Annual Compliance",
        CORP_SEC_1_SHAREHOLDER_SHORT_TEXT: "(1 Shareholder)",
        CORP_SEC_2_SHAREHOLDER_SHORT_TEXT: "(2 Shareholder)",
        CORP_SEC_3_5_SHAREHOLDER_SHORT_TEXT: "(3 to 5 Shareholders)",
        CORP_SEC_6_9_SHAREHOLDER_SHORT_TEXT: "(6 to 9 Shareholders)",
        CORP_SEC_10_20_SHAREHOLDER_SHORT_TEXT: "(10 to 20 Shareholders)",
        CORP_SEC_21_30_SHAREHOLDER_SHORT_TEXT: "(21 to 30 Shareholders)",
        CORP_SEC_31_50_SHAREHOLDER_SHORT_TEXT: "(31 to 50 Shareholders)",
        ACCT_2_500_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "2,500",
        ACCT_7_500_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "7,500",
        ACCT_15_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "15,000",
        ACCT_35_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "35,000",
        ACCT_75_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "75,000",
        ACCT_125_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "125,000",
        ACCT_175_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "175,000",
        ACCT_250_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "250,000",
        ACCT_325_000_EXPENSE_ACCOUNTING_PLAN_SHORT_TEXT: "325,000",
        dormant_company_compliance_yearly: "CO -Dormant company compliance-Yearly",
        "75_000_expense_tax_return_only_yearly": "CO -Tax return only-< $75k-Yearly",
        "250_000_expense_tax_return_only_yearly": "CO -Tax return only-< $250k-Yearly",
        "500_000_expense_tax_return_only_yearly": "CO -Tax return only-< $500k-Yearly",
        "2_000_000_expense_tax_return_only_yearly": "CO -Tax return only-< $2M-Yearly",
        "75_000_expense_accounting_tax_yearly": "CO -Accounting and Tax-< $75k-Yearly",
        "250_000_expense_accounting_tax_yearly": "CO -Accounting and Tax-< $250k-Yearly",
        "500_000_expense_accounting_tax_yearly": "CO -Accounting and Tax-< $500k-Yearly",
        "2_000_000_expense_accounting_tax_yearly": "CO -Accounting and Tax-< $2M-Yearly",
        "75_000_expense_accounting_tax_payroll_yearly": "CO -Accounting, Tax and payroll-< $75k-Yearly",
        "250_000_expense_accounting_tax_payroll_yearly": "CO -Accounting, Tax and payroll-< $250k-Yearly",
        "500_000_expense_accounting_tax_payroll_yearly": "CO -Accounting, Tax and payroll-< $500k-Yearly",
        "2_000_000_expense_accounting_tax_payroll_yearly": "CO -Accounting, Tax and payroll-< $2M-Yearly",
        "75_000_expense_accounting_tax_monthly": "CO -Accounting and Tax-< $75k-Monthly",
        "250_000_expense_accounting_tax_monthly": "CO -Accounting and Tax-< $250k-Monthly",
        "500_000_expense_accounting_tax_monthly": "CO -Accounting and Tax-< $500k-Monthly",
        "2_000_000_expense_accounting_tax_monthly": "CO -Accounting and Tax-< $2M-Monthly",
        "75_000_expense_accounting_tax_payroll_monthly": "CO -Accounting, Tax and payroll-< $75k-Monthly",
        "250_000_expense_accounting_tax_payroll_monthly": "CO -Accounting, Tax and payroll-< $250k-Monthly",
        "500_000_expense_accounting_tax_payroll_monthly": "CO -Accounting, Tax and payroll-< $500k-Monthly",
        "2_000_000_expense_accounting_tax_payroll_monthly": "CO -Accounting, Tax and payroll-< $2M-Monthly",
        "75_000_expense_individual_tax_return_yearly": "ST -Individual Tax Return-< $75k-Yearly",
        "75_000_expense_sole_trader_tax_return_yearly": "ST -Sole Trader Tax Return-< $75k-Yearly",
        "75_000_expense_sole_trader_accounting_tax_yearly": "ST -Sole Trader Tax & Accounting-< $75k-Yearly",
        "250_000_expense_sole_trader_accounting_tax_yearly": "ST -Sole Trader Tax & Accounting-< $250k-Yearly",
        "500_000_expense_sole_trader_accounting_tax_yearly": "ST -Sole Trader Tax & Accounting-< $500k-Yearly",
        "75_000_expense_sole_trader_accounting_tax_monthly": "ST -Sole Trader Tax & Accounting-< $75k-Monthly",
        "250_000_expense_sole_trader_accounting_tax_monthly": "ST -Sole Trader Tax & Accounting-< $250k-Monthly",
        "500_000_expense_sole_trader_accounting_tax_monthly": "ST -Sole Trader Tax & Accounting-< $500k-Monthly",
        enterprise_adhoc_0_yearly: "CO -Enterprise plan-Ad hoc-Yearly",
        enterprise_adhoc_1_yearly: "CO -Enterprise plan-Ad hoc-Yearly",
        enterprise_adhoc_0_monthly: "CO -Enterprise plan-Ad hoc-Monthly",
        enterprise_adhoc_1_monthly: "CO -Enterprise plan-Ad hoc-Monthly",
        add_on_xero_multi_currency_yearly: "Add-on-Xero Multicurrency-Yearly",
        add_on_individual_tax_return_yearly: "Add-on-Individual tax return-Yearly",
        add_on_tax_planning_with_a_senior_tax_agent: "Add-on-Tax Planning with a Senior Tax Agent",
        add_on_rental_property_yearly: "Add-on-Rental Property-Yearly",
        add_on_crypto_tax_return_yearly: "Add-on-Crypto Tax Return-Yearly",
        add_on_cgt_event_yearly: "Add-on-CGT Event-Yearly",
        add_on_registered_address_virtual_mailroom_yearly: "Add-on-Registered Address&Virtual Mailroom-Yearly",
        add_on_monthly_activity_statement_yearly: "Add-on-Monthly Activity Statement-Yearly",
        add_on_additional_payroll_seat_yearly: "Add-on-Additional payroll seat-Yearly",
        add_on_monthly_activity_statement_monthly: "Add-on-Monthly Activity Statement-Monthly",
        add_on_additional_payroll_seat_monthly: "Add-on-Additional payroll seat-Monthly",
      },
    },
    $referral: {
      referral_program: "Referral Program",
      invite_fulltext: "{0} and {1} for every successful referral",
      invite_1: "Invite your friends",
      invite_2: "earn {amount}",
      message1: "Your friends will get {amount} discount on Sleek Services!",
      message2: "Share your referral code and start earning!",
      copied: "Copied!",
      remark:
        "Referral is successful when your code is used during checkout for new incorporations or for transferring services to Sleek.",
      referral_activity: "Referral Activity",
      message3: "Your referrals will be displayed here each time your referral code is used.",
      contact_fulltext: "Should you have any questions, simply {0}.",
      contact_1: "contact us",
      no_referral: "You haven't referred anyone yet!",
    },
    $mailroom: {
      mailroom: "Mailroom",
      search_mail: "Search Mail",
      download: "Download",
      date_desc: "Date (Newest to Oldest)",
      mailbox_empty: "Your mailbox is empty",
    },
    $company: {
      id: {
        company_info: "Company Information",
        business_profile: "BUSINESS PROFILE OF <span>{businessProfile}</span>",
        information_text:
          "No edit allowed on this page as all information requires formal update with your registered Business profile.",
        company_registration_number_label: "CR no.",
        business_number_label: "Business Registration Number (BR No.)",
        incorp_date: "Incorporation Date",
        financial_year: "Financial Year",
        fye_title: "Financial Year End",
        agm_title: "Annual General Meeting (AGM)",
        ar_title: "Annual Return",
        tr_title: "Tax return (Form C/C-S)",
        orless: "or less",
        company_name: "Company Name",
        company_status: "Company Status",
        registered_office_addr: "REGISTERED OFFICE ADDRESS",
        principal_activities: "PRINCIPAL ACTIVITIES",
        company_deadlines: "COMPANY DEADLINES",
        primary_activity: "Primary Activity",
        secondary_activity: "Secondary Activity",
        capital: "CAPITAL",
        share_name: "Share Name",
        ordinary: "Ordinary",
        total_paidup_capital: "Total Paid-up Capital",
        total_issued_capital: "Total Issued Share Capital",
        total_no_of_shares: "Total Number of Shares",
        currency: "Currency",
        address: "Address",
      },
      organization: {
        my_organization: "My Organization",
        directors: "Directors",
        no_edit:
          "No edit as the information is from Companies Registry and requires formal update with Companies Registry.",
        shareholders: "Shareholders",
        standard_user: "Standard User",
        standard_users: "Standard users",
        add_director: "Add Director",
        add_shareholder: "Add Shareholder",
        add_standard_user: "Add standard user",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        mobile_number: "Mobile Number",
        add: "Add",
        required_field: "Required field.",
        contact_information: "Contact Information",
        transfer_ownership: "Transfer ownership",
        transfer_ownership_to: "Transfer ownership to",
        corporate_shareholder: "Corporate Shareholder",
        individual_shareholder: "Individual Shareholder",
        ownership_successfully_transfer: "Ownership successfully transferred.",
        user_not_registered: "Selected user is not registered.",
        max_shareholder_reached: "Max number of shareholders reached. Please remove to add again.",
        invalid_email: "Email must be valid",
        save: "Save",
        cancel: "Cancel",
        copy_to_clipboard: "Copy to clipboard",
        copied_to_clipboard: "Copied to clipboard",
        invitation_has_been_sent: "Invitation has been sent",
        required_first_name: "First name is required",
        required_last_name: "Last name is required",
        required_email: "Email is required",
        organization: "Organization",
        individual_shareholders: "Individual shareholders",
        corporate_shareholders: "Corporate shareholders",
        incomplete_idenity_verification_title: "Incomplete identity verification",
        incomplete_idenity_verification_message:
          "Some directors and shareholders have not completed their identity verification.",
        name: "Name",
        role: "Role",
        identity_verification_status: "Identity verification status",
        sleek_nominee_director: "Sleek Nominee Director",
        company_admin: "Company Admin",
        director: "Director",
        shareholder: "Shareholder",
        not_available: "N/A",
        remind_all: "Remind all",
        remind: "Remind",
        reminded: "Reminded",
        email_reminder_sent: "Email reminder sent",
        standard_user_added: "Standard user added",
        ownership_transferred: "Ownership transferred",
        sent_email_reminder_error_title: "Sorry, the email reminder wasn't sent.",
        sent_email_reminder_error_message:
          "Please try again. If this issue keeps happening, <a href='/enquiry' target='_blank'>click here to contact us</a>.",
        resend: "Resend",
        first_name_placeholder: "Enter your first name here",
        last_name_placeholder: "Enter your last name here",
        email_placeholder: "e.g. yourname@example.com",
        required: "Required",
        email_error_message: "Please enter an email address in the format yourname@example.com",
        select_new_ownership: "Select new owner",
        transfer: "Transfer",
        transfer_ownership_error_message: "Sorry, the transfer was unsuccessful. Please try again.",
        last_reminded_today: "Last reminded: Today",
        last_reminded_one_day_ago: "Last reminded: 1 day ago",
        last_reminded_days_ago: "Last reminded: {number} days ago",
        invitation_status: "Invitation status",
        change_your_preferences: "Change your preferences",
        organization_config_title: "You can choose not to show your contact details.",
        do_not_show_phone_number: "Do not show my phone number to other company members",
        do_not_show_email: "Do not show my email to other company members",
        update_do_not_show_email_success: "Your email is now hidden from other company members",
        update_show_email_success: "Your email is now visible to other company members",
        update_do_not_show_phone_number_success: "Your phone number is now hidden from other company members",
        update_show_phone_number_success: "Your phone number is now visible to other company members",
        hide_phone_number_and_email_success: "Your phone number and email are now hidden from other company members",
        show_phone_number_and_email_success: "Your phone number and email are now visible to other company members",
        phone_number_update_is_not_allowed:
          "We don’t allow the change of phone number via the app yet for security reasons. Please write to your account manager if you need to change it.",
      },
    },
    $contact_types: {
      ADMIN: "ADMIN",
      COMPANY_ADMIN: "Company Admin",
      DIRECTOR: "Director",
      INDIVIDUAL_SHAREHOLDER: "Individual Shareholder",
      CORPORATE_SHAREHOLDER: "Corporate Shareholder",
      NOMINEE_DIRECTOR: "Nominee Director",
      STANDARD_USER: "Standard User",
      DIRECTOR_LABEL_COLLECTIVE: "Director",
      SHAREHOLDER_LABEL_COLLECTIVE: "Shareholder",
      DIRECTOR_AND_SHAREHOLDER: "Director and Shareholder",
      DIRECTOR_AND_REPRESENTATIVE_CORPORATE_SHAREHOLDER: "Director and Representative of Corporate Shareholder",
      REPRESENTATIVE_CORPORATE_SHAREHOLDER: "Representative of Corporate Shareholder",
    },
    $enquiry: {
      enquiry: "Enquiry",
      whatcanwehelp: "What can we help with?",
      subject: "Subject",
      referencenumber: "Reference number",
      created: "Created",
      lastacitivity: "Last acitivity",
      status: "Status",
      notsubmitany: "You have not submitted any enquiries.",
      needhelp: "Need help?",
      message: "Message",
      attachment: "Attachment",
      choosefile: "Choose File",
      browse: "Browse",
      format: "Format: PDF, JPG, PNG.",
      maxsize: "Max Size: {limit}MB per file.",
      multiple_files: "Multiple files can be selected in the file dialog box if you need to upload more than one file.",
      send_email: "SEND EMAIL",
      enquiry_sent: "Enquiry sent! We will get back to you within 3 working days.",
      close: "Close",
      required_field: "Required",
      pre_filled_placeholder: {
        director: "Update of Director",
        shareholder: "Update of Shareholder",
      },
      howcanwehelp: "How can we help?",
      workingdaysWe:
        "Fill out the form below, and we will do our best to respond in {response_time_in_day} working days.",
      workingdaysI: "Fill out the form below, and I will do my best to respond in {response_time_in_day} working days.",
      selectcategory: "Select a category",
      subjecttext: "Subject",
      describe: "Describe your enquiry as detailed as possible",
      attachmenttext: "Attachments (optional)",
      dragdrop: "Drag and drop here",
      ortext: "or",
      uploadtext: "Upload",
      formattext: "Format: PDF, JPG, PNG. Max size: 5MB per file.",
      multifiles: "Multiple files allowed.",
      submittext: "Submit",
      enquirysenttext: "Enquiry sent!",
      thankyoutext:
        "Thanks for contacting us. We will get back to you by email in {response_time_in_day} working days.",
      backtodashboardtext: "Back to dashboard",
      backtoSupporttext: "Back to Support",
      submitanotherquerytext: "Submit another query",
      submitanotherenquirytext: "Submit another enquiry",
      submitanenquirytext: "Submit an enquiry",
      wearehereforyou: "we're here for you.",
      checkemail: "Check your email for more details",
      gotoyourenquiries: "Go to Your enquiries",
      yourenquiries: "Your enquiries",
      enquiryescalated: "Enquiry escalated!",
      tour_introducing_sleek: "Introducing your Sleek team",
      tour_need_help: "Need help? Your dedicated team of experts is now just a click away.",
      tour_next: "Next",
      tour_enquiry_glance: "Enquiry statuses at a glance",
      tour_track_your_enquiries: "Track your enquiries in one place.",
      tour_clearer_escalation: "Clearer escalation channels",
      tour_unsatisfied: "Unsatisfied with our response time or quality? Simply inform your Sleek Team Manager.",
      tour_got_it: "Got it",
      tour_back: "Back",
      tour_new: "New",
    },
    $invitations: {
      invitation_status: "Invitation Status of New Companies",
      no_pending: "No pending invitation",
      my_pending_invites: "My pending invites",
      accept_invite: "Accept Invite",
      login: "Login",
      email: "Email",
      password: "Password",
      next: "Next",
      skip_this: "Skip this",
      begin_verification: "Begin verification",
      to_be_director: "Invitation to be Director of {company_name}",
      to_be_individual_shareholder: "Invitation to be Individual Shareholder of [Company name]",
      to_be_corporate_shareholder: "Invitation to be Corporate Shareholder of [Company name]",
      invitation_description:
        "Your verified personal information is required by Hong Kong law before we can set up your account.<br><br>Please prepare following documents and select your profile.",
      foreigner: "Foreigner",
      foreigner_tooltip:
        "A foreigner is a person who:<br /><br /><ul class='pl-3'><li>Does not hold a Hong-Kong identity card (HKID)</li><li>Is not a Hong-Kong citizen (no HK passport)</li><li>Is not a Hong-Kong resident</li></ul><br />The above applies regardless of the current residing location.",
      hkid_holder: "HKID Holder",
      hkid_holder_tooltip:
        "A HKID holder is a person who:<br /><br /><ul class='pl-3'><li>Holds a Hong-Kong identity card (HKID)</li><li>Is not a Hong-Kong citizen (no HK passport)</li><li>Has the right to reside in Hong-Kong</li></ul><br /> The above applies regardless of the current residing location.",
      hk_citizen: "Hong-Kong Citizen",
      hk_citizen_tooltip:
        "Hong-Kong citizen is person who:<br /><br /><ul class='pl-3'><li>Holds a Hong-Kong identity card (HKID)</li><li>Is Hong-Kong citizen (holds a HK passport or has *** marked below the date of birth in his HKID card)</li><li>Has the right to reside in Hong-Kong</li></ul><br /> The above applies regardless of the current residing location.",
      back: "Back",
      get_phone_camera_ready: "Get your phone and camera ready",
      redirect_to_onfido:
        "You will be redirected to OnFido, a partner of Sleek, to carry out e-KYC. In the process, you will need to connect to the system {0}.",
      redirect_to_onfido_once: "once",
      redirect_to_onfido_twice: "two times",
      connect_via_qr_sms_submit_id: "Connect via QR code or SMS to submit {0}",
      id_is_WP_PR_SG: "your {idtype} and selfie`",
      id_biopage: "the biodata page of your Passport & selfie",
      id_hkid: "your HKID card & selfie picture or video",
      connect_via_qr_sms_submit_biodata: "Connect via QR code or SMS to submit the biodata page of the Passport",
      start_verification: "Start verification",
      process_submitting_kyc:
        "You are in the process of submitting your {idtype} and selfie. You will be asked to say a code. Please speak in English.",
      idtype_hkid: "HKID",
      idtype_passport: "Passport",
      almost_done: "Almost done",
      connect_one_more_time:
        "You will need to connect to the system <span class='font-weight-bold'>one more time</span>.",
      personal_information: "Personal information",
      contact_details: "Contact details",
      phone_number: "Phone number",
      required: "Required",
      consent_to_banks: "Consent to release personal information to authorised banks",
      allow_info_for_bank_account: "I allow my information to be released and used for bank account opening",
      residential_information: "Residential information",
      residential_address: "Residential address",
      addr_line_1: "Address line 1",
      addr_line_2: "Address line 2",
      addr_line_3: "Address line 3",
      city: "City",
      state: "State",
      postal_code: "Postal code",
      district: "District",
      country: "Country of residence",
      supporting_document: "Supporting document",
      supporting_document_subtitle: "Please ensure uploaded images are clear.",
      upload_proof_of_residence: "Upload proof of residence less than 3 months old",
      upload_proof_of_residence_tooltip:
        "Acceptable documents include utility bills, bank statements, tax records or other documents issued by government or institutional authorities.<br><br>Documents should not be more than three (3) months old.<br><br>Sleek can accept documents in Chinese, English, French, German, Indonesian, Malay, Portugese, Russian, Spanish and Vietnamese.<br><br>Documents in other languages must be translated into English by a certified translator.<br><br>Many clients choose to work with <a href='https://www.wordsburg.com.sg/' target='_blank'>Wordsburg</a>.<br><br>Contact them at <a href='mailto:info@wordsburg.com.sg'>info@wordsburg.com.sg</a> and mention that you were referred by Sleek.",
      upload_proof_of_residence_description:
        "<p>1 copy of utility bill, bank statement or tax return document.</p><strong>Format:</strong> PDF, JPG, PNG. <strong>Max size:</strong> 10MB per file.",
      add_files: "Add files",
      declaration: "Declaration",
      are_you_pep: "Are you a Politically Exposed Person (PEP) or related to a PEP?",
      pep_description:
        "A PEP is person who is or has been entrusted with any prominent public function in {country}, a country or territory outside {country}, or by an international organisation. By “related”, we mean that you are a parent, spouse, sibling or child of a PEP, or closely connected to a PEP either socially or professionally.",
      country_name: "Hong-Kong S.A.R",
      radio_yes: "Yes",
      radio_no: "No",
      convicted_crime: "Have you ever been convicted of a crime involving fraud or dishonesty?",
      pep_agree_text:
        "I declare that the above information is true and correct. I am aware that I may be subject to prosecution and criminal sanction underwritten law if I am found to have made any false statement which I know to be false or which I do not believe to be true, or if I have intentionally suppressed any material fact.",
      declare_checkbox: "I declare that the above information is true and correct.",
      submit: "Submit",
      save_and_next: "Save & Next",
      save_and_review: "Save & Review",
    },
    $profile: {
      account_profile: "Account Profile",
      my_profile: "My profile",
      salutation: "Salutation",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      change: "Change",
      change_btn: "CHANGE",
      password: "Password",
      dob: "Date of birth",
      invalid_date: "Invalid date. Please input in {dateformat} format.",
      country_code: "Country code",
      phone_number: "Phone Number",
      address: "Address",
      addr_line_1: "Address Line 1",
      addr_line_2: "Address Line 2",
      addr_line_3: "Address Line 3",
      state: "State",
      city: "City",
      country: "Country",
      postal_code: "Postal Code",
      consent: "Consent to release personal information to authorised parties",
      allow: "I allow my information to be released and used for bank account opening",
      notallow: "I do not allow my information to be shared",
      save: "SAVE",
      required: "Required",
      change_email: "Change Email",
      new_email: "New Email",
      current_password: "Current Password",
      change_password: "Change Password",
      confirm_password: "Confirm Password",
      password_not_match: "Passwords do not match.",
      incorrect_password: "Incorrect password",
      invalid_email: "Please provide a valid email address.",
      cancel: "Cancel",
      submit: "Submit",
    },
    $accounting: {
      accounting_title: "Get covered with Accounting & Tax support that is right for you.",
      plans: [],
      services: [],
      service_add_ons: {},
      service_options: {
        ANNUAL_FILLING_BOOKKEEPING: "Accounting Plan - Annual Bookkeeping",
        ACCOUNTING_PAYROLL: "Accounting Plan - Accounting & Payroll",
        ACCOUNTING_PREMIUM: "Accounting Plan - Accounting Premium",
      },
      checkout_accounting_plan_text: "Accounting Plan - ",
      checkout_accounting_plan_text_plain: "Accounting Plan",
      pricing_suffix: "/year",
      packages: {
        packages: "Packages",
        accounting_options: "Accounting options",
        para1_title: "Choose your monthly expenses and we will provide a quote for you.",
        para1_body: "It will be adjusted quarterly if your expenses change over time.",
        para2_body:
          "Get an estimated quote below based on your monthly expenses. Contact us for any enquiry and we will get back to you in 3-5 working days.",
        tooltip1:
          "On average, how much do you spend each month on goods and services that are necessary to your business?",
        tooltip2:
          "Include any payroll or cost of goods sold (COGS) in your estimate. If you’ve paid yourself a draw, do not include this in your expense total.",
        monthly_expenses1: "monthly expenses",
        monthly_expenses2: "Monthly expenses",
        revenue_per_year: "revenue per year",
        revenue_per_financial_year: "Revenue per financial year",
        accounting_year_label: "financial year",
        orless: "or less",
        accounting_fees: "Accounting fees",
        payroll_support: "Payroll support",
        multicurrency_support: "Multi-currency support",
        multicurrency_tooltip:
          "Having multi-currency support will allow your book-keeping to account for business transactions done in more than one currency.",
        included_text1: "What's included",
        included_text2: "Regardless of your monthly expenses, you will receive the following services:",
        whats_included_packages: [
          "Setup & onboarding",
          "Payroll support with Talenox subscription",
          "Monthly bookkeeping",
          "Monthly management report",
          "Xero & digital receipt submission",
        ],
        plan_details: {
          estimated:
            "Monthly expenses is your total spend to run your company including salaries, rent, cost of goods/services and operational costs.",
          total_average: "What is your total average monthly business expenditure?",
          your_average_monthly: "Your average monthly expenses will determine the cost of your plan",
          adjust_your_project:
            "Adjust your projected monthly expenses to see the pricing of our 3 accounting packages.",
          estimated_financial:
            "Monthly expenses is your total spend to run your company including salaries, rent, cost of goods/services and operational costs.",
          compared_all: "Compare all plans",
          compare_plan: "Compare plans",
          all_our_plans: ` All our plans include
          <strong>a video call for onboarding and setup, annual company tax return filling, annual review meeting with tax specialist.</strong>`,
          select_your_plans: "Select your estimated revenue per year",
          selected_estimate: "Selected your estimated average monthly expenses",
          dedicated:
            "Dedicated accountant, bookkeeping, employers return, SleekBooks software, unaudited financial statements and smart receipt submission",
          time_to_respond: "Time to respond",
          management_accounts: "Management accounts",
          payroll: "Payroll",
          tax_structuring: "Tax structuring/planning/advice",
          review_with_sen: "Review with Senior Accountant",
          xero_subscription: "Xero subscription",
          audit_tax_filing: "Audit & tax filing",
          quarterly_bas_reporting: "Quarterly BAS Reporting",
          bookkeeping: "Bookkeeping",
          cloud_base_receipt_app: "Cloud-based receipt app",
          multi_currency_support: "Multi-currency support",
          video_call_for_onboarding_and_setup: "Onboarding and Setup",
          annual_company_tax_return_filling: "Annual company tax return filling",
          annual_review_meeting_with_tax_expert: "Annual review meeting with Tax Expert",
          individual_tax_return: "Individual Tax Return",
          expert_support: "Expert support by email, phone, chat",
          xero_subscription_sole_trader: "Xero subscription (starter only)",
          business_income_and_expenses: "Business income and expenses",
          setup_and_onboarding: "Onboarding and setup",
          gst_filling: "Annual GST filing (one time registration fee of {priceParam} added at checkout)",
          annual_gst_filing: "Annual GST filing (one time registration fee of {priceParam} added at checkout)",
          accounting_options: [],
          accounting_options_popup: [],
          sale_team_in_touch:
            "No problem! Our Sales team will be in touch within 24 hours after you’ve made payment to discuss a suitable plan for your business.",
          faciliate_discussion: "To faciliate the discussion, please specify your estimated average monthly expenses.",
        },
        whats_included_packages_with_accounting_software: [
          { name: "Payroll support" },
          { name: "Setup & onboarding" },
          { name: "Monthly bookkeeping" },
          { name: "Unaudited Financial Statements" },
          { name: "Monthly management report" },
          { name: "ECI & corporate tax return" },
          { name: "Accounting Software", hasDisclaimer: true },
          { name: "Tax support" },
          { name: "Digital Documents Submission" },
          { name: "Multi-currency support" },
        ],
        whats_included_sub_text: "The following services are included for all tiers:",
        accounting_software_disclaimer_text:
          "By default, you get our Sleek accounting software. You can opt-in now or during your onboarding, for the advanced accounting software Xero to access more features.",
        accounting_suggest_plan_text_header:
          "Choose your monthly expenses and we'll suggest a plan that's right for your business.",
        accounting_suggest_plan_text_sub_header: "Adjusted quarterly if your expenses change over time.",
        monthly_expense_sub_text: "Includes payroll",
        add_ons_text: "Add-ons",
        contact_us_not_capital: "Contact us",
        per_financial_year_label: "per financial year",
        contact_me_later: "Contact me later",
        request_thankyou:
          "Thank you ! We have taken into account your request and our Accounting team will contact you within 1 business day.",
        backto_dashboard: "Go back to dashboard",
        accounting_package_none: {
          title: "More than {monthlyExpenses} monthly expense?",
          subtitle: "Let us know and we’ll be in touch shortly.",
        },
        xero_subscription: {
          title: "Xero Subscription",
          descriptionClaimer:
            "You can sign up for Xero via Sleek. We get it up and running for you! If you want to decide later, you can opt-in during the accounting onboarding.",
          descriptionNonClaimer: "Xero accounting software is included in your package and fully covered by Sleek",
          tooltip: {
            title: "Beyond tax & accounting compliance, gain access to more features with Xero:",
            value: [
              "Create your own sales invoice",
              "Connect third party apps",
              "Access your reports anywhere, anytime",
            ],
          },
        },
        xero_subscription_1_year: "Xero Subscription (1 Year)",
        inclusion: {
          monthly_bookkeeping: "Monthly bookkeeping",
          monthly_management_report: "Monthly management report",
          digital_documents_submission: "Digital documents submission",
          setup_onboarding: "Setup & onboarding",
          payroll_support: "Payroll support",
          financial_statements: "Financial Statements",
          track_income_and_expenses: "Track income and expenses",
          multi_currency_support: "Multi-currency support",
        },
        add_xero_subscription: "Add Xero Subscription",
        xero_subscription_sub_title: "Xero - 1 Year Subscription",
        audit_tax_filing: "Audit & tax filing",
        gst_filling_sub_title: "GST Annual Compliance",
        gst_one_time_reg_title: "One-Time GST Registration",
        read_more_link_text: "What is Xero?",
        accounting_software: "Accounting software",
        xero_subscription_optional: {
          unchecked:
            "By default, you get our Sleek Accounting software. Advanced users can opt-in later during the onboarding for Xero at a preferred rate if required.",
          checked: "You have selected Xero as your accounting software.",
        },
        xero_subscription_included: "Xero subscription is included with your accounting plan",
        no_plan_selected: "No plan selected",
      },
      files: {
        files: "Files",
        accounting: "Accounting",
        upload: "Upload",
        upload_document: "Upload document",
        upload_title: "Upload a document",
        upload_file: "Upload file",
        download_file: "Download file",
        preview: "Preview",
        rename: "Rename",
        delete: "Delete",
        cancel: "Cancel",
        audit: "Audit",
        tax: "Tax",
        payroll: "Payroll",
        bank_statements: "Bank Statements",
        management_reports: "Management Reports",
        agreements: "Agreements",
        onboarding: "Onboarding",
        accounting_no_access_text:
          "You are not subscribed to our accounting package(s). If you wish to subscribe, please have a chat with us at <a href='mailto:customer@sleek.hk'>customer@sleek.hk</a>",
        status_uploaded: "Uploaded",
        status_uploading: "Uploading...",
      },
      setup: {
        awaiting_email: "Awaiting Email Verification",
        email_sent1: "An email has been sent to your email.",
        email_sent2: "Please click on the link in the email to verify this account.",
        resend_email: "RESEND EMAIL",
        refresh_page: "Just refresh this page once verified.",
        success: "Success!",
      },
      accounting_plans: {
        title1: "Accounting plans",
        blurb: {
          content_4_1:
            "Your accounting plan will be adjusted according to your average monthly expenses per financial year.",
          content_4_2:
            "If it falls below or above the selected threshold, we will credit it back to your account or invoice you for the pro-rated amount accordingly.",
        },
        title2: "Review and payment",
        pay_now: "Pay Now",
        plans: "Plans",
        billing_yearly: "Billing yearly",
        billing_monthly: "Billing monthly",
        no_monthly_billing: "No monthly billing available",
        card_text: "Your accounting plan",
        card_sub_text:
          "Don't worry, if your annual revenue exceeds the limit you could always upgrade the plan – no service disruptions!",
        your_sleek_accounting_package_ready: "Your Sleek Accounting package is ready!",
      },
      notification_disable_monthly: "Only yearly plan is available",
      save_price_for_pay_yearly: "Save 25% when you pay yearly",
      no_monthly_billing: "No monthly billing available",
      billing_monthly: "Billed monthly",
      billing_yearly_save_25: "Billed yearly (Save 25%)",
      billing_yearly_mobile: "Billed yearly",
      billing_yearly_save_25_mobile: "Save 25% with yearly billing",
      active_or_dormant_company: {
        card_text: "Is your company active or dormant?",
        card_sub_text:
          "A company can be considered dormant or 'inactive' if it is not conducting business, trading and has no other sources of income during a financial year period.",
        active_company:
          "<p style='font-size: 24px'>Yes</p><p style='font-size: 18px; line-height: 24px'>My company is an <strong>active company</strong></p>",
        dormant_company:
          "<p style='font-size: 24px'>No</p><p style='font-size: 18px; line-height: 24px'>My company is a <strong>dormant company</strong></p>",
      },
      company_or_sold_trader: {
        company: "Proprietary limited company",
        sold_trader: "Sole trader",
        australian_business_number: "What is your Australian Business Number?",
        australian_business_description:
          "It is an 11-digit number that is assigned to your business by the Australian Business Registrar (ABR).",
        what_is_abn: "What is an ABN?",
        australian_business_number_title: "Australian Business Number (ABN)",
        business_info_box_title: "Not registered with the ABR?",
      },
      what_type_of_your_business: "What entity type is your business?",
      dormant_company: {
        accounting_plan_for_dormant_company: "Accounting plan for <br /> dormant companies",
      },
      company_name_title: "What is the name of your company?",
      company_name_sub_text:
        "Before incorporating your company in Australia you would need to ensure you have a <strong>unique company name</strong>.",
      company_name_sub_text_2: "Check if your company name is available here. ",
    },
    $preferences: {
      preferences: "Preferences",
      general: "General",
      alternate_email: "Alternate email as point of contact",
      alternate_email_tooltip: "Your alternate email will need to be verified before you can receive notifications",
      add_alternate_email: "Add alternate email",
      use_as_primary_contact: "Using {contact} as primary point of contact.",
      use_as_primary_contact_until_verified:
        "Using {email} as primary point of contact until alternate email is verified.",
      invalid_email: "Invalid e-mail.",
      required: "Required.",
      update: "Update",
      submit: "Submit",
      resend: "Resend",
      saved_successfully: "Successfully updated your company preferences.",
    },
    $sleeksign: {
      navigation: {
        home: "SleekSign",
        send_document: "Send a document",
        document_list: "Document",
        admin_document_list: "Admin Documents",
      },
      send_documents: {
        page_title: "Upload a document",
        text_file_format: "Format: PDF. Max size: 5MB per file.",
        text_file_drop: "Drag and drop here",
        text_file_or: "or",
        text_assigned_to: "ASSIGNED TO",
        text_signee: "Signee",
        text_all_contacts: "All contacts and groups",
        text_new_contact: "New Contact",
        text_recent_templates: "Recent template(s)",
        text_created_at: "Created at",
        text_company_name: "Company Name",
        text_company_folder: "Company Folder",
        file_upload_new_document_title: "New document",
        file_upload_use_saved_template: "Use a saved template",
        // BUTTONS
        button_upload: "Upload",
        button_add_signee: "ADD SIGNEE",
        button_contacts: "CONTACTS",
        button_save_and_next: "SAVE & NEXT",
        button_back_to_file_upload: "Back to document",
        button_back_to_document_data: "Back to add signees",
        button_back_to_document_container: "Back to add signees placeholders",
        button_okay: "Okay",
        button_close: "Close",
        button_back_to_document_list: "BACK TO DOCUMENT LIST",
        button_view_document_list: "VIEW DOCUMENT LIST",
        button_sign_document: "SIGN THE DOCUMENT",
        button_send: "SEND",
        button_add: "Add",
        button_cancel: "Cancel",
        button_update: "UPDATE",
        text_selected: "Selected",
        button_create_template: "Create a template",
        button_lets_get_started: "Let's get started",
        button_edit: "EDIT",
        button_save: "SAVE",
        button_add_me: "add me",
        button_save_template_and_send: "Save Template & Send",
        toggle_save_template: "Save template",
        // FIELD TITLE
        field_title_add_signees: "Add Signees",
        field_title_add_message: "Add message",
        field_title_add_signees_roles: "Add Signee Roles",
        field_title_add_signee_and_their_roles: "Add Signees and their Roles",
        // SAVE TEMPLATE TOGGLE STEPPER
        save_template_toggle_step_1: "Select a signee role from the dropdown menu",
        save_template_toggle_step_1_content:
          "Roles are used as the placeholders for signatures and to manage the signing order. This is for your reference only.",
        save_template_toggle_step_2: "Add signee name and email address",
        save_template_toggle_step_2_content:
          "Signee name and email address are the only things you'll need to add next time you use this template",
        // SECTION TITLE
        section_title_fields: "Fields",
        section_title_ready_to_send: "Ready to send your document?",
        section_title_ready_to_save: "Ready to save your document?",
        // MENU TITLE
        menu_signature: "Signature",
        menu_initials: "Initials",
        menu_date: "Date",
        menu_checkbox: "Checkbox",
        menu_text: "Text",
        // FIELD PLACEHOLDER
        field_input_placeholder_firstname: "First Name",
        field_input_placeholder_lastname: "Last Name",
        field_input_placeholder_email: "Email",
        field_input_placeholder_document_name: "Document Name",
        field_input_placeholder_copy: "Email a copy separated by commas (optional)",
        field_input_placeholder_message: "Message for signees (optional)",
        field_input_placeholder_default_message: "Hi! Please find a document for your signature. Thanks.",
        field_select_placeholder_fix_width: "Fix Width",
        field_input_placeholder_please_specify: "Please specify",
        field_input_placeholder_role: "Role",
        // TOOLTIP
        tootlip_add_fields: "Start adding fields",
        // DOCUMENT INFO
        document_info_section_title_signee: "Signees",
        document_info_section_title_message: "Message for signees (optional)",
        document_info_section_text_send_copy: "Send a copy to (optional, comma-separated)",
        document_info_section_text_edit_to_add: "Edit to add a cc email. It's optional.",
        // FREE SEND DOCUMENT
        document_owner_header: "Your Details",
        document_owner_subheader: "All updates within signed document will be sent to this email.",
        // Validation
        validation_messages: {
          provide_signatures_to_signees: "Please provide a signature field for each signee.",
          document_name_required: "Document name is required",
        },
        // Contacts
        field_input_placeholder_search_contacts: "Search contacts",
        template_welcome_panel: {
          header: "My templates",
          sub_header: "Save time by adding placeholders to documents you often use",
        },
        // PREVIEW
        preview_page: {
          document_details: "Document Details",
          roles: "Roles",
          signees: "Signees",
          message_optional: "Message (optional)",
          save_template: {
            header: "Will you be sending this template again?",
            subheader:
              "Save your placed signee fields for a faster way to send the same document to the same or different group of people.",
            checkbox: "Save template",
            template_name: "Template Name",
          },
        },
        // SUCCESS
        success_page: {
          success_message: "All set! Your document has been sent.",
          next_steps: "Next Steps",
          first_step: "Signees will receive an email to sign the document",
          second_step:
            "When the document has been completely signed, you and all the signees will receive a copy of the signed document",
          create_account_cta: "Create account & track documents",
          send_another_cta: "Send another document",
        },
        // FILE UPLOAD
        file_upload_page: {
          perk_one_header: "Free & unlimited for everyone",
          perk_one_subheader: "Unlimited legally binding e-signatures for all users, zero fees",
          perk_two_header: "Customise once, resend forever",
          perk_two_subheader: "Customise templates easily when you're sending frequently used documents",
          perk_three_header: "Real-time tracking",
          perk_three_subheader: "Track the status of documents for each signatory, and send them reminders on the go",
          perk_four_header: "Save the environment",
          perk_four_subheader: "Till date, users like you have saved over 2.18 tons of paper through SleekSign!",
          upload_document: "Upload a new document",
          document_uploaded: "Document uploaded",
          uploaded: "Uploaded",
          custom_templates: {
            header: "Try out these customer templates!",
            template_name: "Non-Disclosure Agreement for 2 parties",
            preview_cta: "Preview",
          },
          template_list: {
            empty: "You have no templates saved.",
            loading: "Loading templates",
            upload_to_get_started: "Upload a document to get started.",
          },
        },
        // Verification consent
        verification_consent: {
          header: "We need to verify your email before sending the document",
          send_email_otp: "Send OTP via Email",
        },
        // LOGIN POPUP
        login_popup: {
          header: "Login before sending the document",
          subheader: "is an existing account",
          password: "Password",
          forgot_password: "Forgot password?",
          login_and_send_cta: "Log in and send",
          cancel_cta: "Cancel",
          incorrect_password: "Incorrect password",
          required_password: "Password is required",
        },
        // OTP POPUP
        otp_popup: {
          header: "OTP verification",
          subheader_1: "An OTP was sent your email address",
          subheader_2: "OTP is valid for {time}",
          failed_label: "OTP has been expired. Please close dialog and retry",
          verify_cta: "Verify",
        },
        // SAVE AS DRAFT POPUP
        draft_popup: {
          header: "Save document as draft?",
          subheader: "It will be saved in your document list",
          save_draft_cta: "Save draft",
          delete_draft_cta: "Delete draft",
        },
        // ADD MULTIPLE SIGNEES POPUP
        add_multiple_signees_popup: {
          header: "Add Multiple Signees",
          company_users: "Company users",
          recent_contacts: "Recent contacts",
          searching_for_users: "Searching for users",
          company_name: "Company name",
          full_name: "Full name",
          position: "Position",
          email: "Email",
          add_signees_cta: "Add Signees",
          cancel_cta: "Cancel",
        },
      },
      review_document: {
        back_btn: "Back",
        completed_btn: "COMPLETED",
        date: "Date",
        delete_btn: "DELETE",
        decline_tooltip: "Decline to sign",
        header: "Please review and sign the document below.",
        header_cta: "GET STARTED",
        popup_msg_all_fields_signed: "All fields have been signed!",
        decline_modal_title: "Reason for declining",
        decline_modal_sub_title: "This information will be shared only with the sender.",
        decline_modal_cta: "CONFIRM DECLINE",
        decline_modal_cancel: "CANCEL",
        field_navigation_helper: "{count} field left to sign > | {count} fields left to sign >",
        field_navigation_helper_all_signed: "All fields are signed!",
        field_navigation_next_field: "NEXT FIELD",
        document_field_placeholder_signature: "Click to sign",
        document_field_placeholder_text: "Click to add text",
        document_field_placeholder_date: "Click to add date",
        document_field_placeholder_initials: "Click to add initials",
        document_field_delete_btn: "Delete",
        document_field_edit_btn: "Edit",
        create_signature_modal_title: "Create Signature",
        create_signature_modal_saved: "Saved Signatures",
        create_signature_modal_empty_message: "No saved signature. Try typing, drawing or uploading a new signature.",
        create_initials_modal_title: "Create Initials",
        create_initials_modal_saved: "Saved Initials",
        create_initials_modal_empty_message: "No saved initial. Try typing, drawing or uploading a new initial.",
        create_modal_cta_add_everywhere: "ADD THIS EVERYWHERE",
        create_modal_cta_add: "ADD THIS",
        create_modal_type: "Type",
        create_modal_draw: "Draw",
        create_modal_upload: "Upload",
        create_modal_clear: "CLEAR",
        validation_date_error: 'Invalid date format. Format should be "DD/MM/YYYY"',
        validation_decline_empty_reason: "Reason for declining is required",
        image_signature_file_format: "Format: JPEG, JPG, PNG. Max size: 5MB per file.",
      },
      successful_sign: {
        header: "Successfully signed document!",
        sub_header: "You'll receive a copy once everyone has signed.",
        track_message: "Track the signature progress through the document list",
        view_documents_cta: "VIEW DOCUMENTS",
        invite_message: "Invite your friends!",
        packages: {
          unlimited_signatures: "Unlimited electronic signatures for lifetime!",
          stored_in_one_place: "documents stored in one place.",
        },
        friends_email_placeholder: "Friend's Email",
        validation_email_invalid: "Please provide a valid email address.",
        send_invitation_cta: "SEND INVITATION",
      },
      welcome_modal: {
        header: "Welcome to",
        sub_header: "An easy and convenient platform where you can:",
        packages: {
          free: "Sign documents securely, anywhere in the world. For free!",
          templates: "Use templates when you need to send frequently used documents",
        },
        cta_label: "LET'S GET STARTED",
        mark_as_read_cta_label: "Mark as read",
      },
      document_list: {
        header: "Documents",
        search_cta_label: "SEARCH",
        search_box_placeholder: "Search Documents",
        tab_label_all: "All",
        tab_label_awaiting_signature: "Awaiting my signature",
        table_column_label_documents: "Documents",
        table_column_label_status: "Status",
        table_column_label_date: "Date",
        table_empty_message_1: "Loading Documents",
        table_empty_message_2: "No documents found",
        table_empty_message_3: "Try adjusting your filters to find what you're looking for.",
      },
      admin_document_list: {
        header: "Admin Documents",
        search_cta_label: "SEARCH",
        search_box_placeholder: "Search Documents",
        tab_label_all: "All",
        table_column_label_documents: "Documents",
        table_column_label_status: "Status",
        table_column_label_signees: "Signees",
        table_column_label_sender: "Sender",
        table_column_label_date: "Date",
        table_empty_message_1: "Loading Documents",
        table_empty_message_2: "No documents found",
        table_empty_message_3: "Try adjusting your filters to find what you're looking for.",
      },
      document_list_filters: {
        filters_label: "Filters",
        clear_all_label: "Clear All",
        date_filter: {
          date_label: "Date",
          to_label: "To",
          from_label: "From",
          today_label: "Today",
          yesterday_label: "Yesterday",
          last_7_days_label: "Last 7 Days",
          last_30_days_label: "Last 30 Days",
        },
        status_filter: {
          document_status_label: "Document Status",
        },
      },
      document_statuses_labels: {
        draft: "Draft",
        awaiting_signature: "Awaiting Signature",
        declined: "Declined",
        voided: "Voided",
        completed: "Completed",
      },
      account_creation: {
        perks_header: "With a SleekSign account, you can",
        login_header: "Set up password to track your document",
        login_cta: "Login Now",
      },
    },
    $account_verification: {
      message_verified: "Your account has been verified successfully.",
      button_start: "START USING",
    },
    $onboarding: {
      discount_banner: "",
      stepper: {
        step_1: "Company information",
        step_2: {
          option_1: "Company address",
          option_2: "Address",
        },
        step_3: "Directors and shareholders",
        step_4: "Accounting",
        step_business_account: "Business account",
        step_5: "Payment",
        step_shares_allocation: "Company's shares allocation",
      },
      page_title: {
        header_support_number: "Need help? Reach us at",
        speak_to_an_advisor: "Speak to an advisor",
        header_support_number_without_help: "Reach us at",
        page_1: "Let's get started",
        page_2: "Register your company address",
        page_3: "Invite company members",
        page_4: "Your accounting needs",
        page_business_account: "Business account",
        page_5: "Review and pay",
        company_address_centered: "Company address",
        page_new_registered_office_address: "New registered office address",
      },
      blurb: {
        title: "Good to know",
        link_read_more: "Read more >",
        link_local_address: "local registered office address",
        content_1:
          "Enter different variations of your company name in order of preference. Sleek will help you obtain final confirmation prior to incorporation.",
        content_2: {
          text_1: "{countryName} law mandates that every company must have a",
          text_2:
            "at the point of incorporation. This will be your legal address to receive government and bank correspondences.",
        },
        content_3: {
          text_1:
            "Singapore law mandates that all incorporated companies must have at least one local resident director and one shareholder.",
          text_2:
            "You can use your own Local Director (Singaporean Citizen, PR or Entrepass holder) or sign up for our Nominee Local Director service.",
        },
        content_4:
          "Your accounting plan will be adjusted according to your average monthly expenses per financial year. If it falls below or above the selected threshold, we will credit it back to your account or invoice you for the pro-rated amount accordingly.",
        content_business_account:
          "The Sleek Business Account (SBA) is a free Virtual Account for your company, that allows you to instantly start receiving and sending payments. Find out more <a href={link} target='_blank'>here</a>.",
        content_5: "Shares allocation and details will be collected at later steps.",
      },
      card: {
        title: {
          name_check: "Company name checker",
          classify: "Classify your company",
          business: "Business Account",
          company_name: "Company name",
          business_activity: "Business activity",
          source: "Source of funds",
          more: "More about you",
          registered_office_address: "Registered office address",
          directors: "Directors",
          shareholders: "Shareholders",
          company_details: "Company details",
          services_required: "Services required",
        },
        info: {
          source: "Your inputs are an important part of compliance checks.",
          more: "This helps us serve you better",
          registered_office_address: {
            option_1: {
              p_1: "If you don't have a registered company address, use Sleek's.",
              p_2: "We will scan your mails, upload them to your account every week, and notify you.",
            },
            option_2: {
              p_1: "It has to be a physical office address, and cannot be a P.O. box address.",
              p_2: (ctx) => {
                const link = ctx.named("link");
                const linkEnabled = ctx.named("link_enabled");
                const suffix = linkEnabled
                  ? `<a target='_blank' href='${link}'>you meet all the criteria</a>.`
                  : "you meet all the criteria";
                return `Please ensure that ${suffix}`;
              },
            },
          },
          directors: "An email invitation will be sent to company members for identity verification.",
          shareholders: "An email invitation will be sent to company members for identity verification.",
          company_details: "Please ensure details match exactly as registered.",
          services_required:
            "If you are transferring Company Secretary, we will liaise with your current provider for a smooth transfer.",
          beta_new_registed_office_address: {
            alert_text: "Please take note",
            alert: "This is the new registered office address of your company.",
          },
          need_to_add_more_shareholders: {
            title: "Need to add more shareholders?",
            description:
              "We can help! This requires an upgrade to your Corporate Secretary plan.* Kindly email <a href='mailto:{support_email}'>{support_email}</a> with the following details from the additional shareholder(s):",
            li_1: "First name",
            li_2: "Last name",
            li_3: "Email address",
            note: "Please note that adding shareholders may require an upgrade to a higher pricing tier, impacting the annual company secretary fee.",
          },
        },
        buttons: {
          check: "CHECK",
          back: "BACK",
          save_next: "SAVE & NEXT",
          save: "SAVE",
          add: "ADD",
          contact_us: "CONTACT US",
          continue_to_payment: "CONTINUE TO PAYMENT",
          apply: "APPLY",
          pay: "PAY",
          payment_made: "I'VE Made my payment",
          pay_later: "I'll pay later",
          cancel: "Cancel",
          remove: "Remove",
          confirm: "Confirm",
          email_invoice_to_me: "EMAIL INVOICE TO ME",
          go_to_dashboard: "GO TO DASHBOARD",
          proceed: "PROCEED",
          pay_now: "PAY NOW",
        },
        links: {
          promo_code: "Have a promo code?",
          classify: "Here's a quick guide>",
          business_operation_2: "you meet all the criteria",
          change_payment: "Change payment method",
          discount: "Discount",
        },
        extras: {
          business: {
            beta: "BETA",
            free: "included for FREE",
          },
        },
        texts: {
          registered_office_address: {
            option_2: {
              p_1: "It has to be a physical office address, and cannot be a P.O. box address.",
              p_2: (ctx) => {
                const link = ctx.named("link");
                const linkEnabled = ctx.named("link_enabled");
                const suffix = linkEnabled
                  ? `<a target='_blank' href='${link}'>you meet all the criteria</a>.`
                  : "you meet all the criteria.";
                return `Please ensure that ${suffix}`;
              },
            },
          },
        },
      },
      fields: {
        placeholders: {
          company_name_first: "Company Name - First Choice",
          company_name_second: "Company Name - Second Choice",
          company_name_third: "Company Name - Third Choice",
          company_name_business: "Business Name - If different from company name",
          company_activity: "SSIC - Company Activity",
          secondary_ssic: "SSIC - Secondary Company Activity",
          primary_business_activity: "Primary Business Activity",
          secondary_business_activity: "Secondary Business Activity",
          business_activity_description: "Please describe your business activity.",
          secondary_business_activity_description: "Please describe your secondary business.",
          other_reason: "Other reason",
          specify_amount: "Please specify the amount",
          address_type: "Address Type",
          address_line_1: "Address Line 1",
          address_line_2: "Address Line 2",
          postal_code: "Postal Code",
          quarterly_average: "Estimated average monthly expenses.",
          describe_accounting_needs: "Briefly describe any other accounting needs you may have",
          promo_code: "Promo code",
          select_card: "Select a card",
          name_on_card: "Name on Card",
          card_number: "Card Number",
          cvc: "CVC",
          expiry: "Expiration Date (MM/YY)",
          use_existing: "Use an existing contact",
          first_name: "First Name",
          last_name: "Last Name",
          email: "Email",
          type_of_shareholder: "Type of Shareholder",
          company_name: "Company Name",
          country: "Country",
          business_registration_label: "Based on the {registration_label} given",
        },
        select_option: {
          address_type_commercial: "Commercial office",
          address_type_home: "Home office",
          add_new_card: "Add new card",
        },
        form_label: {
          country: "Country",
          toggle_same_address: "Business operation take place at the same address",
          agree_terms: "I agree with the terms & conditions",
          with_accounting: "With accounting plan. Customize in the next step.",
          with_security_deposit: "With S$2000 security deposit. Will be refunded at the end of the term.",
        },
        error_message: {
          company_name: "Company name is required",
          company_name_second_required: "Company Name - Second Choice is required",
          company_name_third_required: "Company Name - Third Choice is required",
          required: "Required field.",
          business_activity_description: "Description must have at least 100 or more characters",
          select_country: "Select at least 1 country.",
          select_one: "Please select at least 1.",
          please_select: "Please select.",
        },
        field_group: {
          source: {
            group_1: {
              question: "Please select all reasons for establishing your company.",
              answer_1: "I reside in Hong Kong",
              answer_2: "Expansion of existing business",
              answer_3: "Entering into Asia",
              answer_4: "Requested by parties we work with",
              answer_5: "Hong Kong is an internationally recognized hub",
            },
            group_2: {
              question: "Please select all sources for your company's fund.",
              answer_1: "Savings from employment",
              answer_2: "Profits generated from business",
              answer_3: "Investment gain",
              answer_4: "Loans (eg Banks or Financial Institutions)",
              answer_5: "Loans from family and friends",
              answer_6: "Personal Savings",
              answer_7: "Inheritance",
              answer_8: "Investors",
            },
            group_3: {
              question: "Please list up to 3 countries in which an important part of your business will take place",
            },
          },
          business: {
            group_1: {
              question: "Projected Types of transactions",
              answer_1: "Local transfers",
              answer_2: "Overseas transfers",
              answer_3: "Cards transactions",
              answer_4: "Other",
            },
            group_2: {
              question: "What is the projected monthly volume of incoming funds for this account?",
              answer_1: "Less than S$10,000",
              answer_2: "S$10,000 - S$50,000",
              answer_3: "S$50,000 - S$150,000",
              answer_4: "More than S$150,000",
              answer_5: "Other",
            },
            group_3: {
              question: "What is the projected monthly volume of outgoing funds for this account?",
              answer_1: "Less than S$10,000",
              answer_2: "S$10,000 - S$50,000",
              answer_3: "S$50,000 - S$150,000",
              answer_4: "More than S$150,000",
              answer_5: "Other",
            },
          },
          more: {
            group_1: {
              question: "What are the next steps/objectives for you?",
              answer_1: "Create a holding and hold assets/shares",
              answer_2: "Employ myself (applying for a workpass/EP/Entrepass if necessary)",
              answer_3: "Move to Singapore",
              answer_4: "Raise funds quickly from VCs or Angels",
              answer_5: "Start my own business, grow steadily and profitably",
              answer_6: "Startup project, we want to grow fast",
              answer_7: "Others, please specify",
              answer_2_hk: "Employ myself (applying for Employment Pass if necessary)",
              answer_3_hk: "Move to Hongkong",
            },
            group_2: {
              question: "How did you hear about us?",
              answer_1: "Search Engine",
              answer_2: "Social Media",
              answer_3: "Referral from an existing client",
              answer_4: "Referral from a friend/Sleek staff",
              answer_5: "Others, please specify",
            },
          },
        },
        success_message: {
          company_name: "Available (Subject to final confirmation by ACRA)",
        },
        misc: {
          others_specify: "Others, please specify",
        },
        select_option_with_description: {
          // Registered address
          address_type_residential: "Residential",
          address_type_residential_sub_text_1: "All communications and notices to the company are addressed to your ",
          address_type_residential_sub_text_2:
            "residential address. Prior approval from Housing Development Board (HDB) ",
          address_type_residential_sub_text_3: "or Urban Redevelopment Authority (URA) is required.",
          address_type_commercial: "Commercial",
          address_type_commercial_sub_text_1: "All communications and notices to the company are addressed to an ",
          address_type_commercial_sub_text_2: "office in a commercial building (e.g. Co-working spaces)",
          // Business address
          business_address_type_residential_sub_text_1:
            "Business activities are conducted at your residential address.",
          business_address_type_residential_sub_text_2: "Prior approval from Housing Development Board (HDB) or Urban",
          business_address_type_residential_sub_text_3: "Redevelopment Authority (URA) is required.",
          business_address_type_commercial_sub_text_1:
            "Business activities are conducted at an office in a commercial building",
          business_address_type_commercial_sub_text_2: "(e.g. Co-working spaces).",
        },
      },
      content_title: {
        registered_address: "Company Address",
        business_operation: "Company Address",
        nominee_director: "Duration for Nominee Director",
        directors: "Directors",
        shareholders: "Shareholders",
      },
      content_paragraph: {
        services_required: {
          p_1: "I need to transfer...",
          p_2: "Details of your current company secretary",
          p_3: "Type ‘N/A’ if you do not have this information at hand.",
        },
        shareholders: {
          p_1: "Starting at",
          p_2: "per year for",
          p_3: "services.",
        },
        accounting: {
          p_1: "Choose your monthly expenses and we will provide a quote for you.",
          p_2: "It will be adjusted quarterly if your expenses change over time.",
          selector_column: {
            col_title: "Accounting fees",
            row_1_text: "Multi-currency support",
            row_2_text: "XBRL Report",
            row_3_text: "GST support",
            row_4_text: "Monthly expenses",
            pricing_suffix: "or less",
            max: {
              text_1: "More than S$125k monthly expense?",
              text_2: "Let us know and we'll be in touch shortly.",
            },
          },
          whats_included: {
            accordion_title: "What's Included",
            p_1: "Regardless of your monthly expenses, you will receive the following services:",
            options: {
              item_1: "Monthly bookkeeping",
              item_2: "Monthly management report",
              item_3: "Xero & digital receipt submission",
              item_4: "Setup & onboarding",
              item_5: "Payroll support",
              item_6: "Unaudited Financial Statements",
              item_7: "ECI & corporate tax return",
              item_8: "Tax support",
            },
            included: {
              multi: {
                title: "Multi-currency support",
                text: "When you need your book-keeping to account for business transactions done in more than one currency while keeping expense low.",
              },
              xbrl: {
                title: "XBRL preparation",
                text: "For companies with corporate shareholders, we will help you prepare and file your financial statements in XBRL format to ACRA.",
              },
            },
          },
          security_deposit:
            "S$2,000 security deposit applies for now, but will be used to offset your future accounting fees.",
          get_in_touch: "Get in touch",
          get_in_touch_content:
            "Let us know your monthly expense (quarterly average) and any other specific requests you may have which are not found above. We will get back to you in 3-5 working days.",
        },
        payment: {
          summary: {
            heading: "Cart summary",
            business_registration_fee_without_mailroom: "Business Registration fee to HKSAR - Incorporation only",
            packages: {
              hkg: {
                incorp_fee: "Incorporation Fee to Company Registry",
                service_fee: "Sleek Service Fee - Incorporation",
                starter_promo: "Starter Promo",
                corp_sec: "Company Secretary\n({count} Shareholder) | Company Secretary\n({count} Shareholders)",
                multiple_corp_sec: "Company Secretary\n({from_num} to {to_num} Shareholders)",
                annual_fee: "Annual Business Registration fee to HKSAR",
                accounting_plan: {
                  inclusions: {},
                },
                price: "HK${prefix}{amount}",
                price_shorthand: "HK$ {amount}K",
              },
              sgp: {
                incorp_fee: "ACRA Fee - Registration Fee and Name Application",
                service_fee: "Incorporation Assistance Fee",
                corp_sec: "Corporate Secretary\n({count} Shareholder) | Corporate Secretary\n({count} Shareholders)",
                multiple_corp_sec: "Corporate Secretary\n({from_num} to {to_num} Shareholders)",
                annual_fee: "ACRA Annual Filing Fee",
                accounting_plan: {
                  inclusions: {
                    bookkeeping: "Monthly bookkeeping",
                    management_report: "Monthly management report",
                    xero_subscription: "Xero & Receipt Bank subscription",
                    setup_onboarding: "Setup & onboarding",
                    payroll_support: "Payroll support",
                    financial_statements: "Unaudited Financial Statements",
                    eci_corp_tax_return: "ECI & corporate tax return",
                    tax_support: "Tax support",
                    xero_multi_currency: "Xero Multi Currency Upgrade",
                    xbrl_file: "Accounting - XBRL File",
                  },
                },
                price: "S${amount_prefix}{amount}",
                price_shorthand: "S${amount}k",
              },
              general: {
                registered_address: "Registered Address & Virtual Mailroom",
                nominee_director: "Nominee Director /year",
                deposit: "Deposit - Nominee Director",
                accounting_plan: "Accounting Plan - Up to {act_fee} Monthly Expenses",
                business_account: "Sleek Business Account",
                free: "Free",
                multi_currency_upgrade: "Multi currency upgrade",
              },
            },
            subtotal: "Subtotal",
            grand_total: "Grand Total (tax included)",
            mode_of_payment: {
              title: "Payment method",
              selection: {
                card: "Credit/debit card",
                bank: "Bank transfer",
              },
            },
          },
          bank_transfer: {
            title: "Pay with bank transfer",
            note: "Note: It may take 2 to 3 working days for your bank transfer to reach us.",
            p_1: "Use the bank details below to make your payment from your bank’s online banking or mobile app.",
            p_2: {
              text_1: "Make sure you include",
              text_2: "in the Reference/Comments section. This is to help up identify your transaction.",
            },
            bank_details: {
              text_1: "After payment is confirmed, you will be able to proceed to the next steps.",
              text_2: "Please include your company name or invoice number as payment reference for your bank transfer.",
              labels: {
                recipient: "Recipient’s name",
                bank: "Bank",
                account_number: "Account number",
                swift_code: "Swift code",
                amount: "Amount to transfer",
                reference: "Reference / Comments",
                bank_transfer: "Bank Transfer (2-3 working days)",
              },
              values: {
                bank_name: "",
                account_number: "",
                account_name: "",
                swift_code: "",
                code_label: "",
              },
            },
          },
          paynow: {
            title: "Pay with PayNow",
            p_1: "Use the PayNow details below to make your payment from your bank’s online banking or mobile app.",
            p_2: {
              text_1: "Make sure you include",
              text_2: "in the Reference/Comments section. This is to help up identify your transaction.",
            },
            p_3: {
              text: "Or scan our QR code if your banking app is from",
              link: "one of these banks",
            },
            p_4: "Paying on mobile? Tap and save or take a screenshot of our QR code and upload it to your banking app.",
            paynow_details: {
              title: "PayNow details",
              labels: {
                uen: "Unique Entity Number (UEN)",
                entity: "Entity Name",
                amount: "Amount to transfer",
                reference: "Reference / Comments",
              },
            },
          },
          success: {
            login: "Login successful",
            thank_you: "Thank you, {name}",
            processed: "Payment has been processed.",
            next_step: "Next steps - Stage 2",
            allocate: "Allocate your company’s shares. Here’s a",
            quick_guide: "quick guide",
            compliance:
              "Compliance: individually complete identity verification for all company members (email invitation has been sent to all).",
            prepare_incorp:
              "Once identity checks are completed, we will prepare incorporation documents for your signatures in Stage 3.",
            minutes: "10 min",
            transfer_next_step:
              "After your payment is received by Sleek, you will be able to proceed to the next step.",
          },
          error: {
            login: "Incorrect email or password.",
          },
        },
      },
      tooltip: {
        nominee_director: {
          p_1: "Nominee Director is a service offered to help our clients to satisfy ACRA's requirement of having a local director at the time of their incorporation.",
          p_2: "It is a non-executive position meaning that you will still require the appointment of a secondary director (can be 100% foreign) who can make executive decisions for the entity, such as authorising the opening of a bank account.",
          p_3: "While we act as your Local Director we require you to take one of our accounting and tax packages or to provide a refundable security deposit to ensure ongoing compliance on your entity's account.",
        },
        shareholders: {
          p_1: "• 1 shareholder: HKD1,300/year",
          p_2: "• 2 shareholder: HKD1,900/year",
          p_3: "• 3-5 shareholder: HKD2,300/year",
          p_4: "• 6-9 shareholder: HKD2,900/year",
          p_5: "• 10-20 shareholder: HKD4,000/year",
          p_6: "• 21-30 shareholder: HKD5,300/year",
          p_7: "• 31 and above shareholders: HKD6,500/year",
          p_8: "View the",
          link: "full list of services >",
        },
        accounting_skip: {
          p_1: "The security deposit will be refunded to you at the end of the term for the Nominee Director which you selected previously.",
          p_2: "The security deposit is only applicable if you are using Sleek’s Nominee Director without accounting plan selected.",
          p_3: "This applies due to the non-executive nature and associated liability of a Nominee Director.",
        },
        accounting_monthly_expenses: {
          p_1: "On average, how much do you spend each month on goods and services that are necessary to your business?",
          p_2: "Include any payroll or cost of goods sold (COGS) in your estimate. If you’ve paid yourself a draw, do not include this in your expense total.",
        },
        accounting_slider: {
          text: "monthly expenses",
        },
        accounting_security_deposit: {
          p_1: "The security deposit will be refunded to you at the end of the term for the Nominee Director which you selected previously.",
          p_2: "The security deposit is only applicable if you are using Sleek’s Nominee Director without accounting plan selected.",
          p_3: "This applies due to the non-executive nature and associated liability of a Nominee Director.",
        },
      },
      label_main_signee: "MAIN SIGNEE",
      label_included: "Included",
      label_sleek_nominee_director: "Sleek Nominee Director",
      tiles: {
        company_address: {
          tile_1: {
            text: "Use Sleek's registered address & Digital Mailroom Service",
            pricing_suffix: "/year",
          },
          tile_2: {
            text: "Use your own company address",
            link: "Eligibility criteria >",
          },
        },
        directors_and_shareholders: {
          tile_1: {
            text: "Use my local resident director",
            link: "Eligibility criteria >",
          },
          tile_2: {
            text_1: "Use Sleek's Nominee Director",
            text_2: "If you are based overseas or need a time buffer to get a local director",
          },
        },
        nominee_directors: {
          tile_1: {
            text: "3 months",
          },
          tile_2: {
            text: "6 months",
          },
          tile_3: {
            text: "12 months",
          },
        },
        accounting: {
          tile_1: {
            text_1: "Accounting options",
            text_2: "From",
            pricing_suffix: "/financial year",
          },
          tile_2: {
            text: "Skip for now",
            pricing_suffix: "security deposit applies.",
          },
          tile_3: {
            text_1: "",
            text_2: "",
          },
        },
      },
      company: {
        business_registration_label: "UEN",
      },
      company_address: {
        fields: [],
        select_option: {
          districts: [],
        },
        default: {
          address_1: "",
          address_2: "",
          address_3: "",
          district: "",
          postal_code: "",
          state: "",
          city: "",
          country: "",
        },
      },
      shareholders: {
        plans: [],
      },
      company_name: {
        title: "Let's get down to business.",
      },
      asic_compliance: {
        title: "ASIC Compliance",
        sub_title: "All your ASIC compliance sorted from Day 1, <br /> so you can focus on your business.",
      },
      abn_tax_compliance: {
        title: "ABN & Tax <br /> Compliance",
      },
      virtual_office: {
        title: "Ensure your privacy & security with a Registered Office & Digital Mailroom",
      },
      checkout: {
        title: "Here’s a quick recap",
      },
      done: {
        title: "You’re doing great ! We’re almost done.",
      },
      payment_bank_transfer: {
        title: "Pay via bank transfer",
        sub_title: "Please use these bank details to make your payment from your bank's online banking or mobile app.",
      },
    },
    $public_onboarding: {
      country: "",
      navigation: {
        steps: "Steps {current_step} of {total_steps}",
      },
      headers: {
        lets_get_down: "Let's get down to business.",
        nice_to_meet_you: "Nice to meet you,\n{name}!",
        company_director: "Will you be a director of this company?",
        how_many_shareholders: "How many shareholders will you have?",
        name_your_company_transfer_flow: "What is the name of your company?",
        mailroom_mandate: "",
        would_you_like_address:
          "Will your company have a physical location other than your home? | Will {company_name} have a physical location other than your home? | x",
        accounting_header_text: "",
        add_ons_service: "Do you need any additional service?",
        youre_doing_great_text: "You’re doing great {user_name}! We’re almost done.",
        youre_doing_great: "You’re doing great! We’re almost done.",
        checkout_page_text: "Your bespoke incorporation package",
        bank_transfer: {
          card_text: "Pay with bank transfer",
          card_sub_text: "Use these bank details to make your payment from your bank's online banking or mobile app.",
          bank_details:
            "Make sure you include <strong>{invoice_number}</strong> in the Reference/Comments section. This is to help up identify your transaction.",
          bank_transfer_header: "Sleek’s Bank Details",
          receipient_name: "Recipient’s name",
          bank: "Bank",
          account_number: "Account number",
          code_label: "Swift code",
          amount_to_transfer: "Amount to transfer",
          note: "Note: It may take 2 to 3 working days for your bank transfer to reach us.",
          btn_payment: "I’ve made my payment",
          btn_pay_later: "I'll pay later",
          reference_comments: "Reference / Comments",
        },
      },
      sub_headers: {
        whats_your_name: "First things first, what's your name?",
        whats_your_name_and_email: "First things first, what's your name and email address?",
        what_company_name: "What would you like to name your company?",
        before_incorp_unique_company_name:
          "Before incorporating your company in {country_name}, you would need to ensure you have a <strong> unique company name</strong>.",
        always_skip_and_decide_later:
          "Check if your company name is available here. You can always skip this step and decide on your company name later.",
        corporate_secretary_will_keep:
          "Our Corporate Secretary will keep your company on top of all the regulatory affairs. It is priced based on the number of shareholders (irrespective if they are individuals or corporate).",
        they_ensure_legal_compliant:
          "They ensure your company is legally compliant with local law, starting with appointing at least one legally mandated shareholder and one local resident director.",
        must_register_address:
          "We do not support registering residential business addresses. If a residential business address is needed, find more info",
        thinking_of_residential: "",
        mailroom_price_text: "",
        mailroom_too_description: "",
        accounting_sub_header_text: "",
        accounting_sub_header_text2: "",
        add_ons_sub_header_text: "Simply click on a service to add it to your accounting package.",
        checkout_page_sub_text: "Based on what you told us, we suggest moving forward with the following services:",
      },
      fields: {
        form_label: {
          your_name: "Your first name",
          check_availability: "Check availability",
          company_name: "Company name",
          your_company_name: "Your company name",
          your_email: "Email address",
          checkbox_label:
            "Allow Sleek to stay in touch regarding new products and updates. You can unsubscribe at anytime.",
        },
        placeholder: {
          company_name: "Unicorn & Rainbows",
        },
      },
      copy: {
        desired_company_names: "Desired company names:",
        no_of_shareholders: "Number of shareholders:",
        any_csh: "Are there any corporate shareholders?",
        add_on_for_csh:
          "If you have corporate shareholder(s), XBRL report preparation will be added to your cart as per required by ACRA.",
        secretary_label: "",
        this_role_text: "This role takes care of:",
        cs_role_description: [
          "Preparation & filing of annual return",
          "Appointments, resignations, & changes in particulars for directors, auditors, secretaries",
          "Distribution of dividends",
          "Maintenance of company records",
          "Overall compliance with local laws and much more",
        ],
        shareholder_role_description: {
          text_1:
            "Singapore incorporated companies must have one shareholder and one local resident director. This can be the same person.",
          text_2: "You can also add more shareholders at a later time.",
        },
        corporate_shareholder_role_description:
          "A corporate shareholder is a business entity that owns shares in another limited company. The term ‘corporate shareholder’ may refer to another limited company, a limited liability partnership or a non-profit organisation or charity",
        accounting_support_message:
          "Choose your projected monthly expense and we'll suggest a plan that's right for your business.",
        satisfaction_guaranteed_text: "100% Satisfaction Guaranteed",
        satisfaction_guaranteed_subtext:
          "We will refund the fees engaged within the first 30 days, should you be unhappy with our service.",
        satisfaction_guaranteed_subtext_with_sleek:
          "We will refund the Sleek fees engaged within the first 30 days, should you be unhappy with our service.",
        what_to_expect_next_text: "What to expect next",
        what_to_expect_steps: [
          {
            message: "Complete your company information",
            duration: "2 mins",
          },
          {
            message: "Register your company address",
            duration: "2 mins",
          },
          {
            message: "Invite company members and allocate your company’s shares",
            duration: "10 mins",
          },
          {
            message: "Sign and process documents",
            duration: "2 days",
          },
        ],
        what_to_expect_steps_au_accounting_transfer: [
          {
            message: "Verify your email address",
            duration: "2 mins",
          },
          {
            message: "Create a password for your Sleek account",
            duration: "2 mins",
          },
          {
            message: "Setup your company in Sleek",
            duration: "5 mins",
          },
          {
            message: "Complete accounting onboarding",
            duration: "10 mins",
          },
        ],
        what_to_expect: {
          incorporation: [
            {
              message: "Verify your email address",
              duration: "2 mins",
            },
            {
              message: "Create a password for your Sleek account",
              duration: "2 mins",
            },
            {
              message: "Setup your company in Sleek",
              duration: "5 mins",
            },
            {
              message: "Complete accounting onboarding",
              service: "accounting",
              duration: "10 mins",
            },
          ],
        },
      },
      buttons: {
        brainstorming: "I'm still brainstorming a name",
        skip_for_now_decide_later: "Skip for now, I'll decide later.",
        name_availability: "Check availability",
        save_for_later: "Save for later",
        save_for_later_mobile: "Save",
        show_more: "Show more",
        show_less: "Show less",
        add_on_services: "Add-on services",
        need_guidance: "Need Guidance?",
      },
      toggle_buttons: {
        toggle_yes: "Yes",
        toggle_no: "No",
        has_csh: "I have a corporate shareholder(s)",
        no_csh: "I don't have a corporate shareholder",
      },
      accordion: {
        company_secretary: {
          title: "Company secretary",
        },
        shareholders: {
          title: "Shareholders",
        },
        corporate_shareholders: {
          title: "Corporate Shareholders",
        },
        considered_expense: {
          title: "What is included?",
          p_1: "There are several types of expenses in a business. The most common way to categorize them is into operating vs. non-operating and fixed vs. variable.",
          p_2: "Operating expenses a business incurs through its normal business operations such as:",
          operating_expenses: [
            "Cost of Goods Sold (COGS)  – for example: cost of labour, cost of materials, etc",
            "Marketing, advertising, and promotion",
            "Salaries, benefits, and wages",
            "Selling, general, and administrative (SG&A) –for example:",
            { description: "cost to sell, cost to deliver, cost to manage the company", ls_none: true },
            "Rent and insurance",
            "Depreciation and amortization",
          ],
          p_4: "Non-operating expenses that are not related to normal business operations, such as:",
          non_operating_expenses: ["Interest", "Taxes", "Impairment charges"],
          p_5: "Fixed expenses that does not change and remain the same every month, even though there may be an increase or decrease in business activity in sales or production, such as:",
          fixed_expenses: ["Rent", "Salaries, benefits, and wages (sometimes fixed and sometimes variable)"],
          p_6: "Variable expenses that keep changing every month depending on the business activity in sales or production, such as:",
          variable_expenses: [
            "Transaction fees",
            "Commissions",
            "Marketing and advertising (sometimes fixed and sometimes variable)",
          ],
        },
      },
      footnote: {
        company_name_availability:
          "* Company name availability subject to final confirmation from regulating authority.",
        terms_and_privacy_text:
          "By registering, you accept our <a href='{terms_url}' target='_blank'>Terms of use</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a>.",
        terms_and_privacy_text_data_processing_addendum:
          "By registering, you accept our <a href='{terms_url}' target='_blank'>Terms of use</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a> and <a href='{data_processing_addendum_url}' target='_blank'>Data Processing Addendum</a>",
      },
      duration_labels: {
        months: "{duration} months",
        one_time: "one time",
        per_year: "/ year",
        year: "year",
        financial_year: "financial year",
        per_financial_year: "/ financial year",
        per_financial_year_no_space: "/financial year",
        minutes: "mins",
        days: "days",
      },
      checkout_values: {
        currency_text: "S$",
        whats_included_text: "What's included",
        whats_included_text_straight: "Whats included",
        checkout_button_short: "Proceed to pay",
        checkout_button: "Continue to checkout",
        sub_header: "Save progress and pay later",
        save_package_button: "Save Package",
        edit_package_button: "Edit Package",
        basic_services: [],
        addOn_services: [],
        corporate_secretary_subtext: {
          "corp-sec-1-shareholder": "1 Shareholder",
          "corp-sec-2-shareholder": "2 Shareholders",
          "corp-sec-3-to-5-shareholder": "3 to 5 Shareholders",
          "corp-sec-6-to-9-shareholder": "6-9 Shareholders",
          "corp-sec-10-to-20-shareholder": "10 to 20 Shareholders",
          "corp-sec-21-to-30-shareholder": "21 to 30 Shareholders",
          "corp-sec-31-to-50-shareholder": "31 to 50 Shareholders",
          "corp-sec-1-shareholder-premium": "1 Shareholder",
          "corp-sec-2-shareholder-premium": "2 Shareholders",
          "corp-sec-3-to-5-shareholder-premium": "3 to 5 Shareholders",
          "corp-sec-6-to-9-shareholder-premium": "6-9 Shareholders",
          "corp-sec-10-to-20-shareholder-premium": "10 to 20 Shareholders",
          "corp-sec-21-to-30-shareholder-premium": "21 to 30 Shareholders",
          "corp-sec-31-to-50-shareholder-premium": "31 to 50 Shareholders",
        },
        corporate_shareholders_text: "Company shareholders",
        sub_accounting_adjust_text:
          "Adjust your monthly expenses and we’ll suggest a plan that’s right for your business.",
        sub_accounting_adjust_text_2:
          "Your accounting plan will be adjusted according to your average monthly expenses per financial year. </br> If it falls below or above the selected threshold, we will credit it back to your account or invoice you for the pro-rated amount accordingly.",
        show_more_accounting_included: [],
        show_more_accounting_add_ons_text: "",
        full_accounting_package_included_text: "",
        loading_text: "Loading...",
        up_to: "Up to",
        monthly_expense: "monthly expenses",
        more_than: "More than",
      },
      payment_page_values: {
        back_text: "Back",
        great_choice_text: "Great choice!",
        lets_make_it_official_text: "Let's make it official",
        create_account_pay_text: "Create an account and pay",
        lets_get_your_business_started: "Let's get your business started!",
        payment_details_text: "Payment details",
        payment_options: [],
        login_options: [],
        cardholders_name_text: "Cardholders name",
        card_number_text: "Card number",
        expiration_text: "Expiration",
        cvc_text: "",
        your_contact_details_text: "Your contact details",
        sleek_account_details_text: "Sleek account details",
        first_name_text: "First name",
        last_name_text: "Last name",
        email_text: "Email",
        country_code_text: "Country code",
        phone_text: "Phone",
        all_fields_required_text: "*All fields are required",
        new_user: "New User",
        existing_user: "Existing User",
        allow_sleek_to_stay_in_touch_text:
          "Allow Sleek to stay in touch regarding new products and marketing updates. You can unsubscribe anytime.",
        by_signing_up_text:
          "By signing up you agree to our <a href='{terms_url}' target='_blank'>Terms & Conditions</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a>.",
        by_signing_up_text_data_compliance:
          "By signing up you agree to our <a href='{terms_url}' target='_blank'>Terms & Conditions</a> and <a href='{privacy_url}' target='_blank'>Privacy Policy</a> and <a href='{data_processing_addendum_url}' target='_blank'>Data Processing Addendum</a>",
        additional_fee:
          "A S$30 processing fee will be added for payments made via bank transfer or PayNow to account for the manual processing required by our Finance team. Card payments are exempt from any processing fees.",
        trusted_by: "<p>Trusted by over <span><strong>{number_of_companies}</strong></span> businesses</p>",
        reviews_number: "{number_of_reviews} Google reviews",
      },
      images: {
        loader: "onboarding-loading.gif",
      },
      cart_summary_services: [],
      total: "Total",
      cart_summary: "Cart Summary",
      cart_summary_accounting: {
        accounting_tax: "Accounting Plan - Accounting & Tax </br> ({price} annual revenue)",
        accounting_annual_filling: "Annual Bookkeeping - up to {price} Monthly expenses",
        accounting_payroll: "Accounting & Payroll - up to {price} Monthly expenses",
        accounting_premium: "Accounting Premium - up to {price} Monthly expenses",
        above_value: "Accounting - Above {price} Monthly expenses",
      },
      free: "FREE",
      incorporation_assistance: "Incorporation assistance fee",
      company_registry_fee: "Incorporation fee for company registry",
      accounting_none_selected_text: "Accounting - More than {moneyValue} monthly expenses",
      pending_quotation: "Pending Quotation",
      add_voucher: "Add voucher code",
      payment_completion_values: {
        thank_you_text: "Thank you!",
        after_payment_recieved:
          "After your payment is received by Sleek, you will be able to proceed to the next steps.",
        title_text: "",
        after_payment_steps: [],
        complete_button_text: "",
        payment_complete: "Use the PayNow details to make your payment from your bank's online banking or mobile app.",
      },
      save_for_later_page: {
        have_to_run_text: "Have to run?",
        drop_your_contact_text:
          "Drop your contact details, and we'll email you a link to pick up right where you left off.",
        see_you_soon_text: "See you soon!",
        first_name_text: "First name",
        last_name_text: "Last name",
        email_text: "Email",
        country_code_text: "Country code",
        phone_optional_text: "Phone (optional)",
        save_progress_btn: "Save progress for later",
        send_quote_btn: "Send the quote",
        return_to_homepage_btn: "Return to homepage",
        have_questions_text: "Have questions? Give us a call on",
      },
      need_guidance_page: {
        first_name_text: "First name *",
        last_name_text: "Last name *",
        email_text: "Email address *",
        country_code_text: "Country code",
        phone_optional_text: "Phone number *",
        phone_text: "Phone number *",
        button_submit: "Get in touch",
        button_back: "Go back",
        card_text: "Your Sleek team is here to support you!",
        card_sub_text: "Share your contact details, and we'll get in touch to pick up right where you left off.",
        card_sub_text_2: "See you soon!",
        completed_main_text: "Thank you for getting in touch!",
        completed_sub_text_1: "One of our advisors will contact you within <b>1 business day</b>.",
        completed_sub_text_2: "Can't wait? Give us a call",
        completed_sub_text_3: "You can exit this page or go back to where you left off.",
        banner_main_text: "We’re here to help!",
        banner_sub_text: "Share your progress and get help from our team.",
        banner_action_mobile: "Let’s do it",
      },
      dollar_value: {
        your_sleek_package_text: "Your Sleek Package",
        dollar_value_list: [],
        total: "Total",
      },
      audit_plans: {
        "15_000_audit_plan": "Audit Plan - Up to HKD 15K Monthly Expenses",
        "50_000_audit_plan": "Audit Plan - Up to HKD 50K Monthly Expenses",
        "100_000_audit_plan": "Audit Plan - Up to HKD 100K Monthly Expenses",
        "200_000_audit_plan": "Audit Plan - Up to HKD 200K Monthly Expenses",
        "400_000_audit_plan": "Audit Plan - Up to HKD 400K Monthly Expenses",
        "700_000_audit_plan": "Audit Plan - Up to HKD 700K Monthly Expenses",
      },
      manage_financial: {
        title: "How would you manage your financial compliance?",
        description:
          "To maintain compliance, as a business owner, it is necessary to perform fundamental bookkeeping and accounting tasks that are essential for annual filing.",
        need_sleek_accounting_help:
          "<span class='radio-title'>I need Sleek's accounting help</span> <span style='font-family: Montserrat; font-weight: 400; font-size:14px; line-height: 18px'>(from S$576/year)</span>",
        have_covered: "<span class='radio-title'>I have this covered</span>",
        not_sure_yet: "<span class='radio-title'>Not sure yet</span>",
        try_account_sleek: "Try accounting with Sleek",
        easy_100_online:
          "Easy 100% online & paperless process, all your receipt and documents can be submitted online!",
        dedicated_accountant: "Dedicated accountants well-versed in Singapore accounting and tax regulations",
        timely_and_effortless: "Timely and effortless IRAS Tax Filing with Sleek's dedicated Accountants",
        low_cost_international: "Low cost international money transfers with free Sleek Business Account*",
        subject_to_approval: "*Subject to approval",
        did_you_know_with_ND:
          "<strong>Did you know?</strong><br />Signing up for Sleek’s Accounting service could potentially reduce your invoice by up to <strong>S$1424</strong>, as you won’t have to provide a <strong>S$2,000</strong> refundable deposit required with a Sleek nominee director service. ",
        did_you_know_without_ND:
          "<strong>Did you know?</strong><br />Singapore companies are required to<br /><br /><ul><li>File tax returns with Inland Revenue Authority of Singapore (IRAS) by Nov 30th from the second year of incorporation.</li><li>File Estimated chargeable income (ECI) with the IRAS within 3 months of financial year-end.</li><li>Present unaudited financial statements at Annual general meeting (AGM) within 6 months of financial year-end.</li></ul><br />Relax. Sleek ensures deadlines are met. Stay compliant, seamlessly.",
        would_you_like_to_manage: "Would you like to manage your books and taxes using Sleek's accounting services?",
        yes_interested:
          "<span style='font-weight: 500; font-family:Montserrat; font-size: 20px; line-height: 24px; color: #5E5873'>Yes</span>",
        no_interested:
          "<span style='font-weight: 500; font-family:Montserrat; font-size: 20px; line-height: 24px; color: #5E5873'>No</span>",
        i_am_interested:
          "<span style='font-weight: 700; font-size: 12px; line-height: 20px; color: #000000; margin-top: 1rem'>I am interested</span>",
        decide_later:
          "<span style='font-weight: 700; font-size: 12px; line-height: 20px; color: #000000; margin-top: 1rem'>I'll decide later</span>",
      },
      accounting: {
        total_average_monthly_business_expenditure: "What is your total average monthly business expenditure?",
        select_average_monthly: "Select average monthly expenses",
        choose_your_accounting_plan_right_for_you: "Let’s choose an accounting plan that is right for you",
        accounting_title_sleek_package: "Accounting",
        xero_subscription_basis: "/financial year",
      },
      audit_and_tax: {
        header_text_1: "Need a hand with Audit & Tax Filing?",
        subheader_text_1:
          "Experience a hassle-free tax season with our top-notch CPAs providing 100% online audit and tax filing services.",
        subheader_text_2:
          "Audit of financial statements is mandatory for all companies, except dormant companies, in Hong Kong S.A.R.",
        main_header_text: "What is your total average monthly business expenditure?",
        main_subheader_text:
          "Monthly expenses is your total spend to run your company including salaries, rent, cost of goods/services and operational costs.",
        select_business_expense: "Select average monthly business expenses",
        main_dropdown_subtext: "Your average monthly expenses will determine the cost of your plan",
        whats_included_text: "What’s included in our <strong>Audit and Tax Filing Plan</strong>",
        selected_monthly_expense_text: "Selected monthly expense",
        plain_whats_included_text: "What's included",
        audit_plans_list: [],
        whats_included_list: [],
        checkout_title_ext: "(HK${audit_plan_value} Monthly Expenses)",
        audit_and_tax_plans: {
          "15_000_audit_plan": "Audit & Tax (HK$15,000 monthly expenses)",
          "50_000_audit_plan": "Audit & Tax (HK$50,000 monthly expenses)",
          "100_000_audit_plan": "Audit & Tax (HK$100,000 monthly expenses)",
          "200_000_audit_plan": "Audit & Tax (HK$200,000 monthly expenses)",
          "400_000_audit_plan": "Audit & Tax (HK$400,000 monthly expenses)",
          "700_000_audit_plan": "Audit & Tax (HK$700,000 monthly expenses)",
        },
      },
      send_quote: {
        button: "Send me a quote",
        span: "Need more time?",
        cardText: "Need more time?",
        cardSubText: "If you need more time to decide, that's perfectly fine!",
        cardSubText2:
          "<p>Drop your contact details and we'll send you a link to pick up right where you left off.</p>See you soon!",
      },
    },
    $file_explorer: {
      sort_options: {
        sort_by: "Sort by",
        date_desc: "Date (Newest to Oldest)",
        date_asc: "Date (Oldest to Newest)",
        name_asc: "Name (Ascending)",
        name_desc: "Name (Descending)",
        read: "Read",
        unread: "Unread",
      },
      buttons: {
        ok_btn: "OK",
        cancel_btn: "CANCEL",
      },
      messages: {
        empty: "No files to display.",
      },
      actions: {
        download_item: "Downloading Item",
        mark_as_read: "Marking file as read | Marking files as read",
        mark_as_unread: "Marking file as unread | Marking files as unread",
        delete_item: "Delete Item",
        delete_item_message: 'Are you sure you want to delete the {file_type} "{file_name}"?',
      },
      root_folders: {
        mailroom: "Mailroom",
        secretary: "Secretary",
        accounting: "Accounting",
      },
      corpsec_folders: {
        a_registers: "A - Registers",
        b_shares_cert: "B - Share Certificates",
        c_mins_and_reso: "C - Minutes and Resolutions",
        d_comp_reg_filings: "D - Company Registry Filings",
        e_constitution: "E - Constitution",
        f_misc: "F - Miscellaneous",
        g_kyc: "G - KYC",
        a_1_app_for_allotment: "1 - Register of Application For and Allotment of Shares",
        a_2_transfers: "2 - Register of Transfers",
        a_3_directors: "3 - Register of Directors",
        a_4_directors_shareholders_others: "4 - Register of Directors' Shareholdings and Other Interest",
        a_5_managers_sec_and_auditor: "5 - Register of Managers' Secretaries and Auditors",
        a_6_mortgate_and_charges: "6 - Register of Mortgages and Charges",
        a_7_registrable_controllers: "7 - Register of Registrable Controllers",
        a_8_nominee_directors: "8 - Register of Nominee Directors",
        a_9_members: "9 - Register of Members",
        a_10_registered_office: "10 - Register of Registered Office",
        c_1_directors_meetings_and_resolutions: "1 - Directors' meetings and resolutions",
        c_2_shareholders_meetings_and_resolutions: "2 - Shareholders' meetings and resolutions",
        d_financial_statements: "Financial Statements",
      },
      accounting_folders: {
        audit: "Audit",
        tax: "Tax",
        actg_01_payroll: "01 - Payroll",
        actg_02_bank_statements: "02 - Bank Statements",
        actg_03_management_reports: "03 - Management Reports",
        actg_04_agreements: "04 - Agreements",
        actg_05_onboarding: "05 - Onboarding",
      },
    },
    $onfido: {
      auth_accessibility: {
        back_button: "Cancel",
      },
      cross_device_checklist: {
        button_primary: "Submit verification",
        info: "Tips",
        list_item_doc_one: "Document",
        list_item_selfie: "Selfie",
        list_item_video: "Video",
        subtitle: "Here’s everything you’ve uploaded:",
        title: "One final step",
      },
      cross_device_error_desktop: {
        subtitle: "The link only works on mobile devices",
        title: "Something’s gone wrong",
      },
      cross_device_error_restart: {
        subtitle: "You’ll need to restart your verification on your computer",
        title: "Something’s gone wrong",
      },
      cross_device_intro: {
        button_primary: "Get secure link",
        list_item_finish: "Check back here to finish the submission",
        list_item_open_link: "Open the link and complete the tasks",
        list_item_send_phone: "Send a secure link to your phone",
        subtitle: "Here’s how to do it:",
        title: "Continue on your phone",
      },
      cross_device_return: {
        body: "Your computer may take a few seconds to update",
        subtitle: "You can now return to your computer to continue",
        title: "Uploads successful",
      },
      cross_device_session_linked: {
        button_primary: "Continue",
        info: "Double-check",
        list_item_desktop_open: "Your desktop window remains open",
        list_item_sent_by_you: "This link was sent by you — seek advice if you think this could be a scam",
        subtitle: "Continue with the verification",
        title: "Mobile session linked to your computer",
      },
      doc_confirmation: {
        alert: {
          no_doc_detail: "Make sure it’s fully in the frame",
          no_doc_title: "Document not detected",
        },
        body_id: "Make sure your details are clear and unobstructed",
        body_passport: "Make sure your details are clear and unobstructed",
        button_close: "Close",
        button_primary_redo: "Redo",
        button_primary_upload: "Upload",
        button_secondary_redo: "Redo",
        button_zoom: "Enlarge image",
        title: "Check your image",
      },
      doc_submit: {
        title_id_back: "Submit identity card (back)",
        title_id_front: "Submit identity card (front)",
        title_passport: "Submit passport photo page",
      },
      generic: {
        back: "back",
      },
      get_link: {
        button_copied: "Copied",
        button_copy: "Copy",
        button_submit: "Send link",
        info_qr_how: "How to scan a QR code",
        info_qr_how_list_item_camera: "Point your phone’s camera at the QR code",
        info_qr_how_list_item_download:
          "If it doesn’t work, download a QR code scanner from Google Play or the App Store",
        link_divider: "or choose an alternative method",
        link_qr: "Scan QR code",
        link_sms: "Get link via SMS",
        link_url: "Copy link",
        loader_sending: "Sending",
        number_field_input_placeholder: "Enter mobile number",
        number_field_label: "Enter your mobile number:",
        subtitle_qr: "Scan the QR code with your phone",
        subtitle_sms: "Send this one-time link to your phone",
        subtitle_url: "Send this one-time link to your phone",
        title: "Get your secure link",
        url_field_label: "Copy the link to your mobile browser",
      },
      mobilePhrases: {
        photo_upload: {
          body_id_back: "Take a photo of the back of your card",
          body_id_front: "Take a photo of the front of your card",
          body_passport: "Take a photo of your passport photo page",
        },
        selfie_capture: {
          alert: {
            camera_inactive: {
              detail: "Take a photo using the <fallback>basic camera mode</fallback> instead",
            },
            camera_not_working: {
              detail: "Take a photo using the <fallback>basic camera mode</fallback> instead",
            },
            timeout: {
              detail: "Remember to press the button when you’re done. <fallback>Redo video actions</fallback>",
              title: "Looks like you took too long",
            },
          },
        },
        upload_guide: {
          button_primary: "Take a photo",
          title: "Passport photo page",
        },
      },
      permission: {
        body_both: "We can’t verify you without using both your camera and microphone",
        body_cam: "We can’t verify you without your camera",
        button_primary_both: "Enable both",
        button_primary_cam: "Enable camera",
        subtitle_both: "When prompted, you must enable access for both to continue",
        subtitle_cam: "When prompted, you must enable camera access to continue",
        title_both: "Allow camera and microphone access",
        title_cam: "Allow camera access",
      },
      permission_recovery: {
        button_primary: "Refresh",
        info: "Recovery",
        list_header_both: "Follow these steps to recover access for both:",
        list_item_action_cam: "Refresh this page to restart the identity verification process",
        list_item_how_to_both: "Grant access to your camera and microphone from your browser settings",
        subtitle_both: "Recover camera and microphone access to take a video and complete the verification process",
        title_both: "Camera and microphone access denied",
      },
      photo_upload: {
        button_take_photo: "Take photo",
        button_upload: "Upload",
      },
      selfie_capture: {
        alert: {
          camera_inactive: {
            title: "Camera not working?",
          },
        },
      },
      selfie_confirmation: {
        subtitle: "Make sure your entire face is visible",
        title: "Check your selfie",
      },
      sms_sent: {
        info: "Tips",
        info_link_expire: "Your link will expire in one hour",
        info_link_window: "Keep this window open while using your mobile",
        link: "Resend link",
        subtitle: "We’ve sent a secure link to %{number}",
        subtitle_minutes: "It may take a few minutes to arrive",
        title: "Check your mobile",
      },
      switch_phone: {
        info: "Tips",
        info_link_expire: "Your mobile link will expire in one hour",
        info_link_refresh: "Don’t refresh this page",
        info_link_window: "Keep this window open while using your mobile",
        link: "Cancel",
        subtitle: "Once you’ve finished we’ll take you to the next step",
        title: "Connected to your mobile",
      },
      upload_guide: {
        image_detail_blur_label: "All details must be clear — nothing blurry",
        image_detail_cutoff_label: "Show all details — including the bottom 2 lines",
        image_detail_glare_label: "Move away from direct light — no glare",
        image_detail_good_label: "The photo should clearly show your document",
        subtitle: "Scans and photocopies are not accepted",
      },
      video_capture: {
        body: "Keep your face within the oval",
        body_record: "Press the button when you’re ready",
        button_primary_finish: "Finish recording",
        button_primary_next: "Next step",
        header: {
          challenge_digit_instructions: "Say each digit out loud",
          challenge_turn_forward: "then face forward",
          challenge_turn_left: "Turn your head left",
          challenge_turn_right: "Turn your head right",
        },
      },
      video_confirmation: {
        title: "Check your video",
      },
      video_intro: {
        button_primary: "Record video",
        list_item_actions: "You have 20 seconds to finish",
        list_item_speak: "Follow the instructions to move or speak",
        title: "Record a video",
      },
    },
    $maps: {
      countries: [
        {
          name: "Afghanistan",
          value: "Afghanistan",
          alpha2Code: "AF",
          alpha3Code: "AFG",
          callingCodes: ["93"],
          demonym: "Afghan",
        },
        {
          name: "Åland Islands",
          value: "Åland Islands",
          alpha2Code: "AX",
          alpha3Code: "ALA",
          callingCodes: ["358"],
          demonym: "Ålandish",
        },
        {
          name: "Albania",
          value: "Albania",
          alpha2Code: "AL",
          alpha3Code: "ALB",
          callingCodes: ["355"],
          demonym: "Albanian",
        },
        {
          name: "Algeria",
          value: "Algeria",
          alpha2Code: "DZ",
          alpha3Code: "DZA",
          callingCodes: ["213"],
          demonym: "Algerian",
        },
        {
          name: "American Samoa",
          value: "American Samoa",
          alpha2Code: "AS",
          alpha3Code: "ASM",
          callingCodes: ["1684"],
          demonym: "American Samoan",
        },
        {
          name: "Andorra",
          value: "Andorra",
          alpha2Code: "AD",
          alpha3Code: "AND",
          callingCodes: ["376"],
          demonym: "Andorran",
        },
        {
          name: "Angola",
          value: "Angola",
          alpha2Code: "AO",
          alpha3Code: "AGO",
          callingCodes: ["244"],
          demonym: "Angolan",
        },
        {
          name: "Anguilla",
          value: "Anguilla",
          alpha2Code: "AI",
          alpha3Code: "AIA",
          callingCodes: ["1264"],
          demonym: "Anguillian",
        },
        {
          name: "Antarctica",
          value: "Antarctica",
          alpha2Code: "AQ",
          alpha3Code: "ATA",
          callingCodes: ["672"],
          demonym: "",
        },
        {
          name: "Antigua and Barbuda",
          value: "Antigua and Barbuda",
          alpha2Code: "AG",
          alpha3Code: "ATG",
          callingCodes: ["1268"],
          demonym: "Antiguan, Barbudan",
        },
        {
          name: "Argentina",
          value: "Argentina",
          alpha2Code: "AR",
          alpha3Code: "ARG",
          callingCodes: ["54"],
          demonym: "Argentinean",
        },
        {
          name: "Armenia",
          value: "Armenia",
          alpha2Code: "AM",
          alpha3Code: "ARM",
          callingCodes: ["374"],
          demonym: "Armenian",
        },
        {
          name: "Aruba",
          value: "Aruba",
          alpha2Code: "AW",
          alpha3Code: "ABW",
          callingCodes: ["297"],
          demonym: "Aruban",
        },
        {
          name: "Australia",
          value: "Australia",
          alpha2Code: "AU",
          alpha3Code: "AUS",
          callingCodes: ["61"],
          demonym: "Australian",
        },
        {
          name: "Austria",
          value: "Austria",
          alpha2Code: "AT",
          alpha3Code: "AUT",
          callingCodes: ["43"],
          demonym: "Austrian",
        },
        {
          name: "Azerbaijan",
          value: "Azerbaijan",
          alpha2Code: "AZ",
          alpha3Code: "AZE",
          callingCodes: ["994"],
          demonym: "Azerbaijani",
        },
        {
          name: "Bahamas",
          value: "Bahamas",
          alpha2Code: "BS",
          alpha3Code: "BHS",
          callingCodes: ["1242"],
          demonym: "Bahamian",
        },
        {
          name: "Bahrain",
          value: "Bahrain",
          alpha2Code: "BH",
          alpha3Code: "BHR",
          callingCodes: ["973"],
          demonym: "Bahraini",
        },
        {
          name: "Bangladesh",
          value: "Bangladesh",
          alpha2Code: "BD",
          alpha3Code: "BGD",
          callingCodes: ["880"],
          demonym: "Bangladeshi",
        },
        {
          name: "Barbados",
          value: "Barbados",
          alpha2Code: "BB",
          alpha3Code: "BRB",
          callingCodes: ["1246"],
          demonym: "Barbadian",
        },
        {
          name: "Belarus",
          value: "Belarus",
          alpha2Code: "BY",
          alpha3Code: "BLR",
          callingCodes: ["375"],
          demonym: "Belarusian",
        },
        {
          name: "Belgium",
          value: "Belgium",
          alpha2Code: "BE",
          alpha3Code: "BEL",
          callingCodes: ["32"],
          demonym: "Belgian",
        },
        {
          name: "Belize",
          value: "Belize",
          alpha2Code: "BZ",
          alpha3Code: "BLZ",
          callingCodes: ["501"],
          demonym: "Belizean",
        },
        {
          name: "Benin",
          value: "Benin",
          alpha2Code: "BJ",
          alpha3Code: "BEN",
          callingCodes: ["229"],
          demonym: "Beninese",
        },
        {
          name: "Bermuda",
          value: "Bermuda",
          alpha2Code: "BM",
          alpha3Code: "BMU",
          callingCodes: ["1441"],
          demonym: "Bermudian",
        },
        {
          name: "Bhutan",
          value: "Bhutan",
          alpha2Code: "BT",
          alpha3Code: "BTN",
          callingCodes: ["975"],
          demonym: "Bhutanese",
        },
        {
          name: "Bolivia (Plurinational State of)",
          value: "Bolivia (Plurinational State of)",
          alpha2Code: "BO",
          alpha3Code: "BOL",
          callingCodes: ["591"],
          demonym: "Bolivian",
        },
        {
          name: "Bonaire, Sint Eustatius and Saba",
          value: "Bonaire, Sint Eustatius and Saba",
          alpha2Code: "BQ",
          alpha3Code: "BES",
          callingCodes: ["5997"],
          demonym: "Dutch",
        },
        {
          name: "Bosnia and Herzegovina",
          value: "Bosnia and Herzegovina",
          alpha2Code: "BA",
          alpha3Code: "BIH",
          callingCodes: ["387"],
          demonym: "Bosnian, Herzegovinian",
        },
        {
          name: "Botswana",
          value: "Botswana",
          alpha2Code: "BW",
          alpha3Code: "BWA",
          callingCodes: ["267"],
          demonym: "Motswana",
        },
        {
          name: "Bouvet Island",
          value: "Bouvet Island",
          alpha2Code: "BV",
          alpha3Code: "BVT",
          callingCodes: [""],
          demonym: "",
        },
        {
          name: "Brazil",
          value: "Brazil",
          alpha2Code: "BR",
          alpha3Code: "BRA",
          callingCodes: ["55"],
          demonym: "Brazilian",
        },
        {
          name: "British Indian Ocean Territory",
          value: "British Indian Ocean Territory",
          alpha2Code: "IO",
          alpha3Code: "IOT",
          callingCodes: ["246"],
          demonym: "Indian",
        },
        {
          name: "United States Minor Outlying Islands",
          value: "United States Minor Outlying Islands",
          alpha2Code: "UM",
          alpha3Code: "UMI",
          callingCodes: [""],
          demonym: "American",
        },
        {
          name: "Virgin Islands (British)",
          value: "Virgin Islands (British)",
          alpha2Code: "VG",
          alpha3Code: "VGB",
          callingCodes: ["1284"],
          demonym: "Virgin Islander",
        },
        {
          name: "Virgin Islands (U.S.)",
          value: "Virgin Islands (U.S.)",
          alpha2Code: "VI",
          alpha3Code: "VIR",
          callingCodes: ["1 340"],
          demonym: "Virgin Islander",
        },
        {
          name: "Brunei Darussalam",
          value: "Brunei Darussalam",
          alpha2Code: "BN",
          alpha3Code: "BRN",
          callingCodes: ["673"],
          demonym: "Bruneian",
        },
        {
          name: "Bulgaria",
          value: "Bulgaria",
          alpha2Code: "BG",
          alpha3Code: "BGR",
          callingCodes: ["359"],
          demonym: "Bulgarian",
        },
        {
          name: "Burkina Faso",
          value: "Burkina Faso",
          alpha2Code: "BF",
          alpha3Code: "BFA",
          callingCodes: ["226"],
          demonym: "Burkinabe",
        },
        {
          name: "Burundi",
          value: "Burundi",
          alpha2Code: "BI",
          alpha3Code: "BDI",
          callingCodes: ["257"],
          demonym: "Burundian",
        },
        {
          name: "Cambodia",
          value: "Cambodia",
          alpha2Code: "KH",
          alpha3Code: "KHM",
          callingCodes: ["855"],
          demonym: "Cambodian",
        },
        {
          name: "Cameroon",
          value: "Cameroon",
          alpha2Code: "CM",
          alpha3Code: "CMR",
          callingCodes: ["237"],
          demonym: "Cameroonian",
        },
        {
          name: "Canada",
          value: "Canada",
          alpha2Code: "CA",
          alpha3Code: "CAN",
          callingCodes: ["1"],
          demonym: "Canadian",
        },
        {
          name: "Cabo Verde",
          value: "Cabo Verde",
          alpha2Code: "CV",
          alpha3Code: "CPV",
          callingCodes: ["238"],
          demonym: "Cape Verdian",
        },
        {
          name: "Cayman Islands",
          value: "Cayman Islands",
          alpha2Code: "KY",
          alpha3Code: "CYM",
          callingCodes: ["1345"],
          demonym: "Caymanian",
        },
        {
          name: "Central African Republic",
          value: "Central African Republic",
          alpha2Code: "CF",
          alpha3Code: "CAF",
          callingCodes: ["236"],
          demonym: "Central African",
        },
        {
          name: "Chad",
          value: "Chad",
          alpha2Code: "TD",
          alpha3Code: "TCD",
          callingCodes: ["235"],
          demonym: "Chadian",
        },
        {
          name: "Chile",
          value: "Chile",
          alpha2Code: "CL",
          alpha3Code: "CHL",
          callingCodes: ["56"],
          demonym: "Chilean",
        },
        {
          name: "China",
          value: "China",
          alpha2Code: "CN",
          alpha3Code: "CHN",
          callingCodes: ["86"],
          demonym: "Chinese",
        },
        {
          name: "Christmas Island",
          value: "Christmas Island",
          alpha2Code: "CX",
          alpha3Code: "CXR",
          callingCodes: ["61"],
          demonym: "Christmas Island",
        },
        {
          name: "Cocos (Keeling) Islands",
          value: "Cocos (Keeling) Islands",
          alpha2Code: "CC",
          alpha3Code: "CCK",
          callingCodes: ["61"],
          demonym: "Cocos Islander",
        },
        {
          name: "Colombia",
          value: "Colombia",
          alpha2Code: "CO",
          alpha3Code: "COL",
          callingCodes: ["57"],
          demonym: "Colombian",
        },
        {
          name: "Comoros",
          value: "Comoros",
          alpha2Code: "KM",
          alpha3Code: "COM",
          callingCodes: ["269"],
          demonym: "Comoran",
        },
        {
          name: "Congo",
          value: "Congo",
          alpha2Code: "CG",
          alpha3Code: "COG",
          callingCodes: ["242"],
          demonym: "Congolese (Congo)",
        },
        {
          name: "Congo (Democratic Republic of the)",
          value: "Congo (Democratic Republic of the)",
          alpha2Code: "CD",
          alpha3Code: "COD",
          callingCodes: ["243"],
          demonym: "Congolese (DRC)",
        },
        {
          name: "Cook Islands",
          value: "Cook Islands",
          alpha2Code: "CK",
          alpha3Code: "COK",
          callingCodes: ["682"],
          demonym: "Cook Islander",
        },
        {
          name: "Costa Rica",
          value: "Costa Rica",
          alpha2Code: "CR",
          alpha3Code: "CRI",
          callingCodes: ["506"],
          demonym: "Costa Rican",
        },
        {
          name: "Croatia",
          value: "Croatia",
          alpha2Code: "HR",
          alpha3Code: "HRV",
          callingCodes: ["385"],
          demonym: "Croatian",
        },
        {
          name: "Cuba",
          value: "Cuba",
          alpha2Code: "CU",
          alpha3Code: "CUB",
          callingCodes: ["53"],
          demonym: "Cuban",
        },
        {
          name: "Curaçao",
          value: "Curaçao",
          alpha2Code: "CW",
          alpha3Code: "CUW",
          callingCodes: ["599"],
          demonym: "Dutch",
        },
        {
          name: "Cyprus",
          value: "Cyprus",
          alpha2Code: "CY",
          alpha3Code: "CYP",
          callingCodes: ["357"],
          demonym: "Cypriot",
        },
        {
          name: "Czech Republic",
          value: "Czech Republic",
          alpha2Code: "CZ",
          alpha3Code: "CZE",
          callingCodes: ["420"],
          demonym: "Czech",
        },
        {
          name: "Denmark",
          value: "Denmark",
          alpha2Code: "DK",
          alpha3Code: "DNK",
          callingCodes: ["45"],
          demonym: "Danish",
        },
        {
          name: "Djibouti",
          value: "Djibouti",
          alpha2Code: "DJ",
          alpha3Code: "DJI",
          callingCodes: ["253"],
          demonym: "Djibouti",
        },
        {
          name: "Dominica",
          value: "Dominica",
          alpha2Code: "DM",
          alpha3Code: "DMA",
          callingCodes: ["1767"],
          demonym: "Dominican",
        },
        {
          name: "Dominican Republic",
          value: "Dominican Republic",
          alpha2Code: "DO",
          alpha3Code: "DOM",
          callingCodes: ["1809", "1829", "1849"],
          demonym: "Dominican",
        },
        {
          name: "Ecuador",
          value: "Ecuador",
          alpha2Code: "EC",
          alpha3Code: "ECU",
          callingCodes: ["593"],
          demonym: "Ecuadorean",
        },
        {
          name: "Egypt",
          value: "Egypt",
          alpha2Code: "EG",
          alpha3Code: "EGY",
          callingCodes: ["20"],
          demonym: "Egyptian",
        },
        {
          name: "El Salvador",
          value: "El Salvador",
          alpha2Code: "SV",
          alpha3Code: "SLV",
          callingCodes: ["503"],
          demonym: "Salvadoran",
        },
        {
          name: "Equatorial Guinea",
          value: "Equatorial Guinea",
          alpha2Code: "GQ",
          alpha3Code: "GNQ",
          callingCodes: ["240"],
          demonym: "Equatorial Guinean",
        },
        {
          name: "Eritrea",
          value: "Eritrea",
          alpha2Code: "ER",
          alpha3Code: "ERI",
          callingCodes: ["291"],
          demonym: "Eritrean",
        },
        {
          name: "Estonia",
          value: "Estonia",
          alpha2Code: "EE",
          alpha3Code: "EST",
          callingCodes: ["372"],
          demonym: "Estonian",
        },
        {
          name: "Ethiopia",
          value: "Ethiopia",
          alpha2Code: "ET",
          alpha3Code: "ETH",
          callingCodes: ["251"],
          demonym: "Ethiopian",
        },
        {
          name: "Falkland Islands (Malvinas)",
          value: "Falkland Islands (Malvinas)",
          alpha2Code: "FK",
          alpha3Code: "FLK",
          callingCodes: ["500"],
          demonym: "Falkland Islander",
        },
        {
          name: "Faroe Islands",
          value: "Faroe Islands",
          alpha2Code: "FO",
          alpha3Code: "FRO",
          callingCodes: ["298"],
          demonym: "Faroese",
        },
        {
          name: "Fiji",
          value: "Fiji",
          alpha2Code: "FJ",
          alpha3Code: "FJI",
          callingCodes: ["679"],
          demonym: "Fijian",
        },
        {
          name: "Finland",
          value: "Finland",
          alpha2Code: "FI",
          alpha3Code: "FIN",
          callingCodes: ["358"],
          demonym: "Finnish",
        },
        {
          name: "France",
          value: "France",
          alpha2Code: "FR",
          alpha3Code: "FRA",
          callingCodes: ["33"],
          demonym: "French",
        },
        {
          name: "French Guiana",
          value: "French Guiana",
          alpha2Code: "GF",
          alpha3Code: "GUF",
          callingCodes: ["594"],
          demonym: "",
        },
        {
          name: "French Polynesia",
          value: "French Polynesia",
          alpha2Code: "PF",
          alpha3Code: "PYF",
          callingCodes: ["689"],
          demonym: "French Polynesian",
        },
        {
          name: "French Southern Territories",
          value: "French Southern Territories",
          alpha2Code: "TF",
          alpha3Code: "ATF",
          callingCodes: [""],
          demonym: "French",
        },
        {
          name: "Gabon",
          value: "Gabon",
          alpha2Code: "GA",
          alpha3Code: "GAB",
          callingCodes: ["241"],
          demonym: "Gabonese",
        },
        {
          name: "Gambia",
          value: "Gambia",
          alpha2Code: "GM",
          alpha3Code: "GMB",
          callingCodes: ["220"],
          demonym: "Gambian",
        },
        {
          name: "Georgia",
          value: "Georgia",
          alpha2Code: "GE",
          alpha3Code: "GEO",
          callingCodes: ["995"],
          demonym: "Georgian",
        },
        {
          name: "Germany",
          value: "Germany",
          alpha2Code: "DE",
          alpha3Code: "DEU",
          callingCodes: ["49"],
          demonym: "German",
        },
        {
          name: "Ghana",
          value: "Ghana",
          alpha2Code: "GH",
          alpha3Code: "GHA",
          callingCodes: ["233"],
          demonym: "Ghanaian",
        },
        {
          name: "Gibraltar",
          value: "Gibraltar",
          alpha2Code: "GI",
          alpha3Code: "GIB",
          callingCodes: ["350"],
          demonym: "Gibraltar",
        },
        {
          name: "Greece",
          value: "Greece",
          alpha2Code: "GR",
          alpha3Code: "GRC",
          callingCodes: ["30"],
          demonym: "Greek",
        },
        {
          name: "Greenland",
          value: "Greenland",
          alpha2Code: "GL",
          alpha3Code: "GRL",
          callingCodes: ["299"],
          demonym: "Greenlandic",
        },
        {
          name: "Grenada",
          value: "Grenada",
          alpha2Code: "GD",
          alpha3Code: "GRD",
          callingCodes: ["1473"],
          demonym: "Grenadian",
        },
        {
          name: "Guadeloupe",
          value: "Guadeloupe",
          alpha2Code: "GP",
          alpha3Code: "GLP",
          callingCodes: ["590"],
          demonym: "Guadeloupian",
        },
        {
          name: "Guam",
          value: "Guam",
          alpha2Code: "GU",
          alpha3Code: "GUM",
          callingCodes: ["1671"],
          demonym: "Guamanian",
        },
        {
          name: "Guatemala",
          value: "Guatemala",
          alpha2Code: "GT",
          alpha3Code: "GTM",
          callingCodes: ["502"],
          demonym: "Guatemalan",
        },
        {
          name: "Guernsey",
          value: "Guernsey",
          alpha2Code: "GG",
          alpha3Code: "GGY",
          callingCodes: ["44"],
          demonym: "Channel Islander",
        },
        {
          name: "Guinea",
          value: "Guinea",
          alpha2Code: "GN",
          alpha3Code: "GIN",
          callingCodes: ["224"],
          demonym: "Guinean",
        },
        {
          name: "Guinea-Bissau",
          value: "Guinea-Bissau",
          alpha2Code: "GW",
          alpha3Code: "GNB",
          callingCodes: ["245"],
          demonym: "Guinea-Bissauan",
        },
        {
          name: "Guyana",
          value: "Guyana",
          alpha2Code: "GY",
          alpha3Code: "GUY",
          callingCodes: ["592"],
          demonym: "Guyanese",
        },
        {
          name: "Haiti",
          value: "Haiti",
          alpha2Code: "HT",
          alpha3Code: "HTI",
          callingCodes: ["509"],
          demonym: "Haitian",
        },
        {
          name: "Heard Island and McDonald Islands",
          value: "Heard Island and McDonald Islands",
          alpha2Code: "HM",
          alpha3Code: "HMD",
          callingCodes: [""],
          demonym: "Heard and McDonald Islander",
        },
        {
          name: "Holy See",
          value: "Holy See",
          alpha2Code: "VA",
          alpha3Code: "VAT",
          callingCodes: ["379"],
          demonym: "",
        },
        {
          name: "Honduras",
          value: "Honduras",
          alpha2Code: "HN",
          alpha3Code: "HND",
          callingCodes: ["504"],
          demonym: "Honduran",
        },
        {
          name: "Hong Kong S.A.R",
          value: "Hong Kong S.A.R",
          alpha2Code: "HK",
          alpha3Code: "HKG",
          callingCodes: ["852"],
          demonym: "Chinese",
        },
        {
          name: "Hungary",
          value: "Hungary",
          alpha2Code: "HU",
          alpha3Code: "HUN",
          callingCodes: ["36"],
          demonym: "Hungarian",
        },
        {
          name: "Iceland",
          value: "Iceland",
          alpha2Code: "IS",
          alpha3Code: "ISL",
          callingCodes: ["354"],
          demonym: "Icelander",
        },
        {
          name: "India",
          value: "India",
          alpha2Code: "IN",
          alpha3Code: "IND",
          callingCodes: ["91"],
          demonym: "Indian",
        },
        {
          name: "Indonesia",
          value: "Indonesia",
          alpha2Code: "ID",
          alpha3Code: "IDN",
          callingCodes: ["62"],
          demonym: "Indonesian",
        },
        {
          name: "Côte d'Ivoire",
          value: "Côte d'Ivoire",
          alpha2Code: "CI",
          alpha3Code: "CIV",
          callingCodes: ["225"],
          demonym: "Ivorian",
        },
        {
          name: "Iran (Islamic Republic of)",
          value: "Iran (Islamic Republic of)",
          alpha2Code: "IR",
          alpha3Code: "IRN",
          callingCodes: ["98"],
          demonym: "Iranian",
        },
        {
          name: "Iraq",
          value: "Iraq",
          alpha2Code: "IQ",
          alpha3Code: "IRQ",
          callingCodes: ["964"],
          demonym: "Iraqi",
        },
        {
          name: "Ireland",
          value: "Ireland",
          alpha2Code: "IE",
          alpha3Code: "IRL",
          callingCodes: ["353"],
          demonym: "Irish",
        },
        {
          name: "Isle of Man",
          value: "Isle of Man",
          alpha2Code: "IM",
          alpha3Code: "IMN",
          callingCodes: ["44"],
          demonym: "Manx",
        },
        {
          name: "Israel",
          value: "Israel",
          alpha2Code: "IL",
          alpha3Code: "ISR",
          callingCodes: ["972"],
          demonym: "Israeli",
        },
        {
          name: "Italy",
          value: "Italy",
          alpha2Code: "IT",
          alpha3Code: "ITA",
          callingCodes: ["39"],
          demonym: "Italian",
        },
        {
          name: "Jamaica",
          value: "Jamaica",
          alpha2Code: "JM",
          alpha3Code: "JAM",
          callingCodes: ["1876"],
          demonym: "Jamaican",
        },
        {
          name: "Japan",
          value: "Japan",
          alpha2Code: "JP",
          alpha3Code: "JPN",
          callingCodes: ["81"],
          demonym: "Japanese",
        },
        {
          name: "Jersey",
          value: "Jersey",
          alpha2Code: "JE",
          alpha3Code: "JEY",
          callingCodes: ["44"],
          demonym: "Channel Islander",
        },
        {
          name: "Jordan",
          value: "Jordan",
          alpha2Code: "JO",
          alpha3Code: "JOR",
          callingCodes: ["962"],
          demonym: "Jordanian",
        },
        {
          name: "Kazakhstan",
          value: "Kazakhstan",
          alpha2Code: "KZ",
          alpha3Code: "KAZ",
          callingCodes: ["76", "77"],
          demonym: "Kazakhstani",
        },
        {
          name: "Kenya",
          value: "Kenya",
          alpha2Code: "KE",
          alpha3Code: "KEN",
          callingCodes: ["254"],
          demonym: "Kenyan",
        },
        {
          name: "Kiribati",
          value: "Kiribati",
          alpha2Code: "KI",
          alpha3Code: "KIR",
          callingCodes: ["686"],
          demonym: "I-Kiribati",
        },
        {
          name: "Kuwait",
          value: "Kuwait",
          alpha2Code: "KW",
          alpha3Code: "KWT",
          callingCodes: ["965"],
          demonym: "Kuwaiti",
        },
        {
          name: "Kyrgyzstan",
          value: "Kyrgyzstan",
          alpha2Code: "KG",
          alpha3Code: "KGZ",
          callingCodes: ["996"],
          demonym: "Kirghiz",
        },
        {
          name: "Lao People's Democratic Republic",
          value: "Lao People's Democratic Republic",
          alpha2Code: "LA",
          alpha3Code: "LAO",
          callingCodes: ["856"],
          demonym: "Laotian",
        },
        {
          name: "Latvia",
          value: "Latvia",
          alpha2Code: "LV",
          alpha3Code: "LVA",
          callingCodes: ["371"],
          demonym: "Latvian",
        },
        {
          name: "Lebanon",
          value: "Lebanon",
          alpha2Code: "LB",
          alpha3Code: "LBN",
          callingCodes: ["961"],
          demonym: "Lebanese",
        },
        {
          name: "Lesotho",
          value: "Lesotho",
          alpha2Code: "LS",
          alpha3Code: "LSO",
          callingCodes: ["266"],
          demonym: "Mosotho",
        },
        {
          name: "Liberia",
          value: "Liberia",
          alpha2Code: "LR",
          alpha3Code: "LBR",
          callingCodes: ["231"],
          demonym: "Liberian",
        },
        {
          name: "Libya",
          value: "Libya",
          alpha2Code: "LY",
          alpha3Code: "LBY",
          callingCodes: ["218"],
          demonym: "Libyan",
        },
        {
          name: "Liechtenstein",
          value: "Liechtenstein",
          alpha2Code: "LI",
          alpha3Code: "LIE",
          callingCodes: ["423"],
          demonym: "Liechtensteiner",
        },
        {
          name: "Lithuania",
          value: "Lithuania",
          alpha2Code: "LT",
          alpha3Code: "LTU",
          callingCodes: ["370"],
          demonym: "Lithuanian",
        },
        {
          name: "Luxembourg",
          value: "Luxembourg",
          alpha2Code: "LU",
          alpha3Code: "LUX",
          callingCodes: ["352"],
          demonym: "Luxembourger",
        },
        {
          name: "Macao",
          value: "Macao",
          alpha2Code: "MO",
          alpha3Code: "MAC",
          callingCodes: ["853"],
          demonym: "Chinese",
        },
        {
          name: "Macedonia (the former Yugoslav Republic of)",
          value: "Macedonia (the former Yugoslav Republic of)",
          alpha2Code: "MK",
          alpha3Code: "MKD",
          callingCodes: ["389"],
          demonym: "Macedonian",
        },
        {
          name: "Madagascar",
          value: "Madagascar",
          alpha2Code: "MG",
          alpha3Code: "MDG",
          callingCodes: ["261"],
          demonym: "Malagasy",
        },
        {
          name: "Malawi",
          value: "Malawi",
          alpha2Code: "MW",
          alpha3Code: "MWI",
          callingCodes: ["265"],
          demonym: "Malawian",
        },
        {
          name: "Malaysia",
          value: "Malaysia",
          alpha2Code: "MY",
          alpha3Code: "MYS",
          callingCodes: ["60"],
          demonym: "Malaysian",
        },
        {
          name: "Maldives",
          value: "Maldives",
          alpha2Code: "MV",
          alpha3Code: "MDV",
          callingCodes: ["960"],
          demonym: "Maldivan",
        },
        {
          name: "Mali",
          value: "Mali",
          alpha2Code: "ML",
          alpha3Code: "MLI",
          callingCodes: ["223"],
          demonym: "Malian",
        },
        {
          name: "Malta",
          value: "Malta",
          alpha2Code: "MT",
          alpha3Code: "MLT",
          callingCodes: ["356"],
          demonym: "Maltese",
        },
        {
          name: "Marshall Islands",
          value: "Marshall Islands",
          alpha2Code: "MH",
          alpha3Code: "MHL",
          callingCodes: ["692"],
          demonym: "Marshallese",
        },
        {
          name: "Martinique",
          value: "Martinique",
          alpha2Code: "MQ",
          alpha3Code: "MTQ",
          callingCodes: ["596"],
          demonym: "French",
        },
        {
          name: "Mauritania",
          value: "Mauritania",
          alpha2Code: "MR",
          alpha3Code: "MRT",
          callingCodes: ["222"],
          demonym: "Mauritanian",
        },
        {
          name: "Mauritius",
          value: "Mauritius",
          alpha2Code: "MU",
          alpha3Code: "MUS",
          callingCodes: ["230"],
          demonym: "Mauritian",
        },
        {
          name: "Mayotte",
          value: "Mayotte",
          alpha2Code: "YT",
          alpha3Code: "MYT",
          callingCodes: ["262"],
          demonym: "French",
        },
        {
          name: "Mexico",
          value: "Mexico",
          alpha2Code: "MX",
          alpha3Code: "MEX",
          callingCodes: ["52"],
          demonym: "Mexican",
        },
        {
          name: "Micronesia (Federated States of)",
          value: "Micronesia (Federated States of)",
          alpha2Code: "FM",
          alpha3Code: "FSM",
          callingCodes: ["691"],
          demonym: "Micronesian",
        },
        {
          name: "Moldova (Republic of)",
          value: "Moldova (Republic of)",
          alpha2Code: "MD",
          alpha3Code: "MDA",
          callingCodes: ["373"],
          demonym: "Moldovan",
        },
        {
          name: "Monaco",
          value: "Monaco",
          alpha2Code: "MC",
          alpha3Code: "MCO",
          callingCodes: ["377"],
          demonym: "Monegasque",
        },
        {
          name: "Mongolia",
          value: "Mongolia",
          alpha2Code: "MN",
          alpha3Code: "MNG",
          callingCodes: ["976"],
          demonym: "Mongolian",
        },
        {
          name: "Montenegro",
          value: "Montenegro",
          alpha2Code: "ME",
          alpha3Code: "MNE",
          callingCodes: ["382"],
          demonym: "Montenegrin",
        },
        {
          name: "Montserrat",
          value: "Montserrat",
          alpha2Code: "MS",
          alpha3Code: "MSR",
          callingCodes: ["1664"],
          demonym: "Montserratian",
        },
        {
          name: "Morocco",
          value: "Morocco",
          alpha2Code: "MA",
          alpha3Code: "MAR",
          callingCodes: ["212"],
          demonym: "Moroccan",
        },
        {
          name: "Mozambique",
          value: "Mozambique",
          alpha2Code: "MZ",
          alpha3Code: "MOZ",
          callingCodes: ["258"],
          demonym: "Mozambican",
        },
        {
          name: "Myanmar",
          value: "Myanmar",
          alpha2Code: "MM",
          alpha3Code: "MMR",
          callingCodes: ["95"],
          demonym: "Burmese",
        },
        {
          name: "Namibia",
          value: "Namibia",
          alpha2Code: "NA",
          alpha3Code: "NAM",
          callingCodes: ["264"],
          demonym: "Namibian",
        },
        {
          name: "Nauru",
          value: "Nauru",
          alpha2Code: "NR",
          alpha3Code: "NRU",
          callingCodes: ["674"],
          demonym: "Nauruan",
        },
        {
          name: "Nepal",
          value: "Nepal",
          alpha2Code: "NP",
          alpha3Code: "NPL",
          callingCodes: ["977"],
          demonym: "Nepalese",
        },
        {
          name: "Netherlands",
          value: "Netherlands",
          alpha2Code: "NL",
          alpha3Code: "NLD",
          callingCodes: ["31"],
          demonym: "Dutch",
        },
        {
          name: "New Caledonia",
          value: "New Caledonia",
          alpha2Code: "NC",
          alpha3Code: "NCL",
          callingCodes: ["687"],
          demonym: "New Caledonian",
        },
        {
          name: "New Zealand",
          value: "New Zealand",
          alpha2Code: "NZ",
          alpha3Code: "NZL",
          callingCodes: ["64"],
          demonym: "New Zealander",
        },
        {
          name: "Nicaragua",
          value: "Nicaragua",
          alpha2Code: "NI",
          alpha3Code: "NIC",
          callingCodes: ["505"],
          demonym: "Nicaraguan",
        },
        {
          name: "Niger",
          value: "Niger",
          alpha2Code: "NE",
          alpha3Code: "NER",
          callingCodes: ["227"],
          demonym: "Nigerien",
        },
        {
          name: "Nigeria",
          value: "Nigeria",
          alpha2Code: "NG",
          alpha3Code: "NGA",
          callingCodes: ["234"],
          demonym: "Nigerian",
        },
        {
          name: "Niue",
          value: "Niue",
          alpha2Code: "NU",
          alpha3Code: "NIU",
          callingCodes: ["683"],
          demonym: "Niuean",
        },
        {
          name: "Norfolk Island",
          value: "Norfolk Island",
          alpha2Code: "NF",
          alpha3Code: "NFK",
          callingCodes: ["672"],
          demonym: "Norfolk Islander",
        },
        {
          name: "Korea (Democratic People's Republic of)",
          value: "Korea (Democratic People's Republic of)",
          alpha2Code: "KP",
          alpha3Code: "PRK",
          callingCodes: ["850"],
          demonym: "North Korean",
        },
        {
          name: "Northern Mariana Islands",
          value: "Northern Mariana Islands",
          alpha2Code: "MP",
          alpha3Code: "MNP",
          callingCodes: ["1670"],
          demonym: "American",
        },
        {
          name: "Norway",
          value: "Norway",
          alpha2Code: "NO",
          alpha3Code: "NOR",
          callingCodes: ["47"],
          demonym: "Norwegian",
        },
        {
          name: "Oman",
          value: "Oman",
          alpha2Code: "OM",
          alpha3Code: "OMN",
          callingCodes: ["968"],
          demonym: "Omani",
        },
        {
          name: "Pakistan",
          value: "Pakistan",
          alpha2Code: "PK",
          alpha3Code: "PAK",
          callingCodes: ["92"],
          demonym: "Pakistani",
        },
        {
          name: "Palau",
          value: "Palau",
          alpha2Code: "PW",
          alpha3Code: "PLW",
          callingCodes: ["680"],
          demonym: "Palauan",
        },
        {
          name: "Palestine, State of",
          value: "Palestine, State of",
          alpha2Code: "PS",
          alpha3Code: "PSE",
          callingCodes: ["970"],
          demonym: "Palestinian",
        },
        {
          name: "Panama",
          value: "Panama",
          alpha2Code: "PA",
          alpha3Code: "PAN",
          callingCodes: ["507"],
          demonym: "Panamanian",
        },
        {
          name: "Papua New Guinea",
          value: "Papua New Guinea",
          alpha2Code: "PG",
          alpha3Code: "PNG",
          callingCodes: ["675"],
          demonym: "Papua New Guinean",
        },
        {
          name: "Paraguay",
          value: "Paraguay",
          alpha2Code: "PY",
          alpha3Code: "PRY",
          callingCodes: ["595"],
          demonym: "Paraguayan",
        },
        {
          name: "Peru",
          value: "Peru",
          alpha2Code: "PE",
          alpha3Code: "PER",
          callingCodes: ["51"],
          demonym: "Peruvian",
        },
        {
          name: "Philippines",
          value: "Philippines",
          alpha2Code: "PH",
          alpha3Code: "PHL",
          callingCodes: ["63"],
          demonym: "Filipino",
        },
        {
          name: "Pitcairn",
          value: "Pitcairn",
          alpha2Code: "PN",
          alpha3Code: "PCN",
          callingCodes: ["64"],
          demonym: "Pitcairn Islander",
        },
        {
          name: "Poland",
          value: "Poland",
          alpha2Code: "PL",
          alpha3Code: "POL",
          callingCodes: ["48"],
          demonym: "Polish",
        },
        {
          name: "Portugal",
          value: "Portugal",
          alpha2Code: "PT",
          alpha3Code: "PRT",
          callingCodes: ["351"],
          demonym: "Portuguese",
        },
        {
          name: "Puerto Rico",
          value: "Puerto Rico",
          alpha2Code: "PR",
          alpha3Code: "PRI",
          callingCodes: ["1787", "1939"],
          demonym: "Puerto Rican",
        },
        {
          name: "Qatar",
          value: "Qatar",
          alpha2Code: "QA",
          alpha3Code: "QAT",
          callingCodes: ["974"],
          demonym: "Qatari",
        },
        {
          name: "Republic of Kosovo",
          value: "Republic of Kosovo",
          alpha2Code: "XK",
          alpha3Code: "KOS",
          callingCodes: ["383"],
          demonym: "Kosovar",
        },
        {
          name: "Réunion",
          value: "Réunion",
          alpha2Code: "RE",
          alpha3Code: "REU",
          callingCodes: ["262"],
          demonym: "French",
        },
        {
          name: "Romania",
          value: "Romania",
          alpha2Code: "RO",
          alpha3Code: "ROU",
          callingCodes: ["40"],
          demonym: "Romanian",
        },
        {
          name: "Russian Federation",
          value: "Russian Federation",
          alpha2Code: "RU",
          alpha3Code: "RUS",
          callingCodes: ["7"],
          demonym: "Russian",
        },
        {
          name: "Rwanda",
          value: "Rwanda",
          alpha2Code: "RW",
          alpha3Code: "RWA",
          callingCodes: ["250"],
          demonym: "Rwandan",
        },
        {
          name: "Saint Barthélemy",
          value: "Saint Barthélemy",
          alpha2Code: "BL",
          alpha3Code: "BLM",
          callingCodes: ["590"],
          demonym: "Saint Barthélemy Islander",
        },
        {
          name: "Saint Helena, Ascension and Tristan da Cunha",
          value: "Saint Helena, Ascension and Tristan da Cunha",
          alpha2Code: "SH",
          alpha3Code: "SHN",
          callingCodes: ["290"],
          demonym: "Saint Helenian",
        },
        {
          name: "Saint Kitts and Nevis",
          value: "Saint Kitts and Nevis",
          alpha2Code: "KN",
          alpha3Code: "KNA",
          callingCodes: ["1869"],
          demonym: "Kittian and Nevisian",
        },
        {
          name: "Saint Lucia",
          value: "Saint Lucia",
          alpha2Code: "LC",
          alpha3Code: "LCA",
          callingCodes: ["1758"],
          demonym: "Saint Lucian",
        },
        {
          name: "Saint Martin (French part)",
          value: "Saint Martin (French part)",
          alpha2Code: "MF",
          alpha3Code: "MAF",
          callingCodes: ["590"],
          demonym: "Saint Martin Islander",
        },
        {
          name: "Saint Pierre and Miquelon",
          value: "Saint Pierre and Miquelon",
          alpha2Code: "PM",
          alpha3Code: "SPM",
          callingCodes: ["508"],
          demonym: "French",
        },
        {
          name: "Saint Vincent and the Grenadines",
          value: "Saint Vincent and the Grenadines",
          alpha2Code: "VC",
          alpha3Code: "VCT",
          callingCodes: ["1784"],
          demonym: "Saint Vincentian",
        },
        {
          name: "Samoa",
          value: "Samoa",
          alpha2Code: "WS",
          alpha3Code: "WSM",
          callingCodes: ["685"],
          demonym: "Samoan",
        },
        {
          name: "San Marino",
          value: "San Marino",
          alpha2Code: "SM",
          alpha3Code: "SMR",
          callingCodes: ["378"],
          demonym: "Sammarinese",
        },
        {
          name: "Sao Tome and Principe",
          value: "Sao Tome and Principe",
          alpha2Code: "ST",
          alpha3Code: "STP",
          callingCodes: ["239"],
          demonym: "Sao Tomean",
        },
        {
          name: "Saudi Arabia",
          value: "Saudi Arabia",
          alpha2Code: "SA",
          alpha3Code: "SAU",
          callingCodes: ["966"],
          demonym: "Saudi Arabian",
        },
        {
          name: "Senegal",
          value: "Senegal",
          alpha2Code: "SN",
          alpha3Code: "SEN",
          callingCodes: ["221"],
          demonym: "Senegalese",
        },
        {
          name: "Serbia",
          value: "Serbia",
          alpha2Code: "RS",
          alpha3Code: "SRB",
          callingCodes: ["381"],
          demonym: "Serbian",
        },
        {
          name: "Seychelles",
          value: "Seychelles",
          alpha2Code: "SC",
          alpha3Code: "SYC",
          callingCodes: ["248"],
          demonym: "Seychellois",
        },
        {
          name: "Sierra Leone",
          value: "Sierra Leone",
          alpha2Code: "SL",
          alpha3Code: "SLE",
          callingCodes: ["232"],
          demonym: "Sierra Leonean",
        },
        {
          name: "Singapore",
          value: "Singapore",
          alpha2Code: "SG",
          alpha3Code: "SGP",
          callingCodes: ["65"],
          demonym: "Singaporean",
        },
        {
          name: "Sint Maarten (Dutch part)",
          value: "Sint Maarten (Dutch part)",
          alpha2Code: "SX",
          alpha3Code: "SXM",
          callingCodes: ["1721"],
          demonym: "Dutch",
        },
        {
          name: "Slovakia",
          value: "Slovakia",
          alpha2Code: "SK",
          alpha3Code: "SVK",
          callingCodes: ["421"],
          demonym: "Slovak",
        },
        {
          name: "Slovenia",
          value: "Slovenia",
          alpha2Code: "SI",
          alpha3Code: "SVN",
          callingCodes: ["386"],
          demonym: "Slovene",
        },
        {
          name: "Solomon Islands",
          value: "Solomon Islands",
          alpha2Code: "SB",
          alpha3Code: "SLB",
          callingCodes: ["677"],
          demonym: "Solomon Islander",
        },
        {
          name: "Somalia",
          value: "Somalia",
          alpha2Code: "SO",
          alpha3Code: "SOM",
          callingCodes: ["252"],
          demonym: "Somali",
        },
        {
          name: "South Africa",
          value: "South Africa",
          alpha2Code: "ZA",
          alpha3Code: "ZAF",
          callingCodes: ["27"],
          demonym: "South African",
        },
        {
          name: "South Georgia and the South Sandwich Islands",
          value: "South Georgia and the South Sandwich Islands",
          alpha2Code: "GS",
          alpha3Code: "SGS",
          callingCodes: ["500"],
          demonym: "South Georgia and the South Sandwich Islander",
        },
        {
          name: "Korea (Republic of)",
          value: "Korea (Republic of)",
          alpha2Code: "KR",
          alpha3Code: "KOR",
          callingCodes: ["82"],
          demonym: "South Korean",
        },
        {
          name: "South Sudan",
          value: "South Sudan",
          alpha2Code: "SS",
          alpha3Code: "SSD",
          callingCodes: ["211"],
          demonym: "South Sudanese",
        },
        {
          name: "Spain",
          value: "Spain",
          alpha2Code: "ES",
          alpha3Code: "ESP",
          callingCodes: ["34"],
          demonym: "Spanish",
        },
        {
          name: "Sri Lanka",
          value: "Sri Lanka",
          alpha2Code: "LK",
          alpha3Code: "LKA",
          callingCodes: ["94"],
          demonym: "Sri Lankan",
        },
        {
          name: "Sudan",
          value: "Sudan",
          alpha2Code: "SD",
          alpha3Code: "SDN",
          callingCodes: ["249"],
          demonym: "Sudanese",
        },
        {
          name: "Suriname",
          value: "Suriname",
          alpha2Code: "SR",
          alpha3Code: "SUR",
          callingCodes: ["597"],
          demonym: "Surinamer",
        },
        {
          name: "Svalbard and Jan Mayen",
          value: "Svalbard and Jan Mayen",
          alpha2Code: "SJ",
          alpha3Code: "SJM",
          callingCodes: ["4779"],
          demonym: "Norwegian",
        },
        {
          name: "Swaziland",
          value: "Swaziland",
          alpha2Code: "SZ",
          alpha3Code: "SWZ",
          callingCodes: ["268"],
          demonym: "Swazi",
        },
        {
          name: "Sweden",
          value: "Sweden",
          alpha2Code: "SE",
          alpha3Code: "SWE",
          callingCodes: ["46"],
          demonym: "Swedish",
        },
        {
          name: "Switzerland",
          value: "Switzerland",
          alpha2Code: "CH",
          alpha3Code: "CHE",
          callingCodes: ["41"],
          demonym: "Swiss",
        },
        {
          name: "Syrian Arab Republic",
          value: "Syrian Arab Republic",
          alpha2Code: "SY",
          alpha3Code: "SYR",
          callingCodes: ["963"],
          demonym: "Syrian",
        },
        {
          name: "Taiwan",
          value: "Taiwan",
          alpha2Code: "TW",
          alpha3Code: "TWN",
          callingCodes: ["886"],
          demonym: "Taiwanese",
        },
        {
          name: "Tajikistan",
          value: "Tajikistan",
          alpha2Code: "TJ",
          alpha3Code: "TJK",
          callingCodes: ["992"],
          demonym: "Tadzhik",
        },
        {
          name: "Tanzania, United Republic of",
          value: "Tanzania, United Republic of",
          alpha2Code: "TZ",
          alpha3Code: "TZA",
          callingCodes: ["255"],
          demonym: "Tanzanian",
        },
        {
          name: "Thailand",
          value: "Thailand",
          alpha2Code: "TH",
          alpha3Code: "THA",
          callingCodes: ["66"],
          demonym: "Thai",
        },
        {
          name: "Timor-Leste",
          value: "Timor-Leste",
          alpha2Code: "TL",
          alpha3Code: "TLS",
          callingCodes: ["670"],
          demonym: "East Timorese",
        },
        {
          name: "Togo",
          value: "Togo",
          alpha2Code: "TG",
          alpha3Code: "TGO",
          callingCodes: ["228"],
          demonym: "Togolese",
        },
        {
          name: "Tokelau",
          value: "Tokelau",
          alpha2Code: "TK",
          alpha3Code: "TKL",
          callingCodes: ["690"],
          demonym: "Tokelauan",
        },
        {
          name: "Tonga",
          value: "Tonga",
          alpha2Code: "TO",
          alpha3Code: "TON",
          callingCodes: ["676"],
          demonym: "Tongan",
        },
        {
          name: "Trinidad and Tobago",
          value: "Trinidad and Tobago",
          alpha2Code: "TT",
          alpha3Code: "TTO",
          callingCodes: ["1868"],
          demonym: "Trinidadian",
        },
        {
          name: "Tunisia",
          value: "Tunisia",
          alpha2Code: "TN",
          alpha3Code: "TUN",
          callingCodes: ["216"],
          demonym: "Tunisian",
        },
        {
          name: "Turkey",
          value: "Turkey",
          alpha2Code: "TR",
          alpha3Code: "TUR",
          callingCodes: ["90"],
          demonym: "Turkish",
        },
        {
          name: "Turkmenistan",
          value: "Turkmenistan",
          alpha2Code: "TM",
          alpha3Code: "TKM",
          callingCodes: ["993"],
          demonym: "Turkmen",
        },
        {
          name: "Turks and Caicos Islands",
          value: "Turks and Caicos Islands",
          alpha2Code: "TC",
          alpha3Code: "TCA",
          callingCodes: ["1649"],
          demonym: "Turks and Caicos Islander",
        },
        {
          name: "Tuvalu",
          value: "Tuvalu",
          alpha2Code: "TV",
          alpha3Code: "TUV",
          callingCodes: ["688"],
          demonym: "Tuvaluan",
        },
        {
          name: "Uganda",
          value: "Uganda",
          alpha2Code: "UG",
          alpha3Code: "UGA",
          callingCodes: ["256"],
          demonym: "Ugandan",
        },
        {
          name: "Ukraine",
          value: "Ukraine",
          alpha2Code: "UA",
          alpha3Code: "UKR",
          callingCodes: ["380"],
          demonym: "Ukrainian",
        },
        {
          name: "United Arab Emirates",
          value: "United Arab Emirates",
          alpha2Code: "AE",
          alpha3Code: "ARE",
          callingCodes: ["971"],
          demonym: "Emirati",
        },
        {
          name: "United Kingdom of Great Britain and Northern Ireland",
          value: "United Kingdom of Great Britain and Northern Ireland",
          alpha2Code: "GB",
          alpha3Code: "GBR",
          callingCodes: ["44"],
          demonym: "British",
        },
        {
          name: "United States of America",
          value: "United States of America",
          alpha2Code: "US",
          alpha3Code: "USA",
          callingCodes: ["1"],
          demonym: "American",
        },
        {
          name: "Uruguay",
          value: "Uruguay",
          alpha2Code: "UY",
          alpha3Code: "URY",
          callingCodes: ["598"],
          demonym: "Uruguayan",
        },
        {
          name: "Uzbekistan",
          value: "Uzbekistan",
          alpha2Code: "UZ",
          alpha3Code: "UZB",
          callingCodes: ["998"],
          demonym: "Uzbekistani",
        },
        {
          name: "Vanuatu",
          value: "Vanuatu",
          alpha2Code: "VU",
          alpha3Code: "VUT",
          callingCodes: ["678"],
          demonym: "Ni-Vanuatu",
        },
        {
          name: "Venezuela (Bolivarian Republic of)",
          value: "Venezuela (Bolivarian Republic of)",
          alpha2Code: "VE",
          alpha3Code: "VEN",
          callingCodes: ["58"],
          demonym: "Venezuelan",
        },
        {
          name: "Viet Nam",
          value: "Viet Nam",
          alpha2Code: "VN",
          alpha3Code: "VNM",
          callingCodes: ["84"],
          demonym: "Vietnamese",
        },
        {
          name: "Wallis and Futuna",
          value: "Wallis and Futuna",
          alpha2Code: "WF",
          alpha3Code: "WLF",
          callingCodes: ["681"],
          demonym: "Wallis and Futuna Islander",
        },
        {
          name: "Western Sahara",
          value: "Western Sahara",
          alpha2Code: "EH",
          alpha3Code: "ESH",
          callingCodes: ["212"],
          demonym: "Sahrawi",
        },
        {
          name: "Yemen",
          value: "Yemen",
          alpha2Code: "YE",
          alpha3Code: "YEM",
          callingCodes: ["967"],
          demonym: "Yemeni",
        },
        {
          name: "Zambia",
          value: "Zambia",
          alpha2Code: "ZM",
          alpha3Code: "ZMB",
          callingCodes: ["260"],
          demonym: "Zambian",
        },
        {
          name: "Zimbabwe",
          value: "Zimbabwe",
          alpha2Code: "ZW",
          alpha3Code: "ZWE",
          callingCodes: ["263"],
          demonym: "Zimbabwean",
        },
      ],
    },
    $create_account: {
      how_can_we_help: "How can we help you today?",
      register_your_business: "Register your business",
      incorporate_your_company: "Incorporate your company with our extremely fast and 100% paperless process.",
      move_to_sleek: "Move to Sleek",
      let_us_help: "Let us help manage your accounting, corporate secretary and compliance matters all in one place!",
      use_sleekSign: "Use SleekSign now",
      free_with_sleekSign: "Upload, send and sign unlimited documents for <b>free</b> with SleekSign.",
      already_have_an_account: "Already have an account?",
      login: "LOGIN",
      next: "NEXT",
      create_sleekSign: "Create a SleekSign account",
      talk_to_an_expert: "Talk to an expert",
      talk_to_an_expert_description:
        "Book a <b>free</b> session with our specialists to uncover the perfect <b>Sleek</b> solution for your business",
      talk_to_an_expert_meeting_url: "",
    },
    $shareholder: {
      services: [],
      default_option: "How many shareholders do you have?",
      number_of_shareholder_determine: "Number of shareholders will determine the cost of your plan",
      number_of_shareholder_determine_content:
        "Hong Kong incorporated companies must have at least one shareholder. You can also add more shareholders at a later time.",
      what_include: "What's included with company secretary plan",
      what_include_content: [
        "Provision of a Company Secretary",
        "Provision of a Designated Representative",
        "Appointment/Change of director/company secretary/auditor",
        "Change in officers' particulars",
        "Change of registered office address",
        "Distribution of dividends",
        "Filing of Annual Return - inclusive of filing fee",
        "Maintenance of the significant controller register",
        "Maintenance of the statutory records of the company",
        "Preparation of the Annual General Meeting (AGM) documents",
        "All of your statutory records and compliance documents in one place, accessible online 24/7",
      ],
      chose_your_secretary_plan: "Choose your company secretary plan",
      sub_title_2:
        "We include Company Secretary as a default with each incorporation service to satisfy compliance requirements in Hong Kong",
    },
  },
};

export default messages;
